import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import DashboardSummary from "../components/DashboardSummary";
import '../../App.css';
import Main from "../../App";
import * as XLSX from "xlsx";
import { Skeleton } from 'primereact/skeleton';
import { InputSearch } from '../components/TextField';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { storeCustomerReminders, storeUpdatePaperless, storeSendPaperless, fetchCustomerReminders, fetchReminderDetail, fetchEventLog, storeClaim} from '../../slice/customerRemindersSlice';
import moment from 'moment';
import { FilterMatchMode } from 'primereact/api';
import { Checkbox } from 'primereact/checkbox';
import Modal from '../components/Modal';
import Swal from 'sweetalert2';
import { Tabs, Tab } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { id } from 'date-fns/locale';
import { registerLocale } from 'react-datepicker';
import { ModalContext } from "../context/ModalContext";
import axios from "axios";
import { saveAs } from "file-saver";
const API_URL = process.env.REACT_APP_ENDPOINT;

// Register Indonesian locale
registerLocale('id', id);
    
function RemindersReport(){
    const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.onmouseenter = Swal.stopTimer;
            toast.onmouseleave = Swal.resumeTimer;
        }
    });

    //Up Selling
    const [upSellingParts, setUpSellingParts] = useState({});
    const [Datapendukung, setDatapendukung] = useState(null); 
    const [activeTab, setActiveTab] = useState("claim");
    const [vin, setVin] = useState("");
    const [historyData, setHistoryData] = useState([]);
    const dispatch = useDispatch();
    const [search, setSearch] = useState('');
    const [filters, setFilters] = useState(null);  
    const [selectedData, setSelectedData] = useState(null);
    const [DataVehiclesList, setDataVehiclesList] = useState(null);
    const [eventlogData, setEventlogData] = useState(null);

    const [dateFrom, setDateFrom] = useState("");
    const [dateTo, setDateTo] = useState("");

    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isEventLogModalOpen, setIsEventLogModalOpen] = useState(false);
    const [isUploadFileModalOpen, setIsUploadFileModalOpen] = useState(false);
    const [isExportModalOpen, setIsExportModalOpen] = useState(false);
    const [fileBase64Map, setFileBase64Map] = useState({});
    const [fileNames, setFileNames] = useState({});
    const [odometer, setOdometer] = useState(selectedData?.km ?? '');

    const [selectedItems, setSelectedItems] = useState([]);
    const { detailData } = useSelector((state) => state.customerReminders);

    const [data, setData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [loading, setLoading] = useState(false);
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(6);
    const [sortField, setSortField] = useState("repair_date");
    const [sortOrder, setSortOrder] = useState(-1); // -1 = desc, 1 = asc
    const [globalFilter, setGlobalFilter] = useState("");

    // const fetchData = async (page = 1) => {
    //     setLoading(true);
    //     try {
    //     const res = await axios.post(`${API_URL}/cust/`, {
    //         page,
    //         rows,
    //         kodecabang: localStorage.getItem('kodecabang'),
    //         sortField,
    //         sortOrder: sortOrder === 1 ? "asc" : "desc",
    //         globalFilter,
    //         filters
    //     });

    //     setData(res.data.data);
    //     setTotalRecords(res.data.total_records);
    //     } catch (err) {
    //     console.error("Error fetching data:", err);
    //     } finally {
    //     setLoading(false);
    //     }
    // };

    const fetchData = async (page = 1, perPage = 6, filter = globalFilter) => {
        setLoading(true);
        try {
            const res = await axios.post(`${API_URL}/cust`, {
            page,
            rows: perPage,
            kodecabang: localStorage.getItem('kodecabang'),
            sortField,
            sortOrder: sortOrder === 1 ? "asc" : "desc",
            globalFilter: filter, // ⬅️ kirim langsung ke backend
            filters, // filter kolom lain seperti statusclaim / repair_date
            });

            setData(res.data.data);
            setTotalRecords(res.data.total_records);
        } catch (err) {
            console.error("Error fetching data:", err);
        } finally {
            setLoading(false);
        }
    };

    const handleSelectStatusFromSummary = (status) => {
        setFilters({
            ...filters,
            statusclaim: {
            value: status,
            matchMode: "equals",
            },
        });

        // kalau tabel lo pakai fetchData(), panggil ulang biar update
        fetchData();
    };

    const onPage = (e) => {
        const page = e.first / e.rows + 1;
        setFirst(e.first);
        setRows(e.rows);
        fetchData(page);
    };

    const onSort = (e) => {
        setSortField(e.sortField);
        setSortOrder(e.sortOrder);
        fetchData(1);
    };

    const onFilter = (e) => {
        setFilters(e.filters);
        fetchData(1);
    };

    useEffect(() => {
        fetchData(1);
    }, []);

    const [isLoadingHistoryVIN, setisLoadingHistoryVIN] = useState(false);
    
    const handleSearchVin = async () => {
        try {
            if (vin === "") {
                Toast.fire({
                    icon: "warning",
                    title: "VIN Belum diisi."
                });
                return;
            }

            setisLoadingHistoryVIN(true);
            const response = await axios.get(
                `${API_URL}/gethistoryclaimvin?vin=${vin}&emailuser=${localStorage.getItem('userEmail')}`
            );

            if (response.status === 200) {
                setisLoadingHistoryVIN(false);
                const data = response.data.data.historyClaimDealerList || [];
                setHistoryData(data);
            } else {
                setisLoadingHistoryVIN(false);
                Toast.fire({
                    icon: "success",
                    title: response.error,
                });
            }
        } catch (error) {
            setisLoadingHistoryVIN(false);
            console.error("Gagal fetch :", error);
            Toast.fire({
                    icon: "error",
                    title: error,
                });
        }
    };

    const handleDownloadExcel = async () => {
        if (!dateFrom || !dateTo) {
            return Toast.fire({
                icon: "warning",
                title: "Tanggal dari dan sampai harus diisi.",
            });
        }

        if (new Date(dateFrom) > new Date(dateTo)) {
            return Toast.fire({
                icon: "warning",
                title: "Tanggal dari tidak boleh lebih besar dari tanggal sampai.",
            });
        }

        try {
            const response = await axios.get(
                `${API_URL}/laporanclaimtowass/export?date_from=${dateFrom}&date_to=${dateTo}&emailuser=${localStorage.getItem('userEmail')}`,
                { responseType: "blob", validateStatus: () => true }
            );

            const contentType = response.headers["content-type"];

            // Jika backend balikin JSON (no data)
            if (contentType && contentType.includes("application/json")) {
                const text = await response.data.text?.();
                const message = JSON.parse(text || "{}")?.message || "Data kosong.";
                Toast.fire({
                    icon: "info",
                    title: message,
                });
                return;
            }

            // Jika beneran Excel
            const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            saveAs(blob, `LaporanClaimTowass_${dateFrom}_sd_${dateTo}.xlsx`);
        } catch (error) {
            console.error("Error download:", error);
            Toast.fire({
                icon: "error",
                title: "Gagal download laporan, harap hubungi IT anda.",
            });
        }
    };


    const handleExportExcel = () => {
        if (!historyData || historyData.length === 0) {
             Toast.fire({
                icon: "warning",
                title: "Data kosong, Harap isi VIN dan klik tombol Cari dahulu sebelum export.",
            });
            return;
        }

        // 🔹 Format data agar header-nya rapi
        const exportData = historyData.map((item, index) => ({
            "No": index + 1,
            "VIN": item.vin ?? "",
            "Openo": item.openo ?? "",
            "Openo Desc": item.openoDesc ?? "",
            "Claim Type": item.claimType ?? "",
            "Repair Date": item.repairDate
            ? new Date(item.repairDate).toLocaleDateString("id-ID")
            : "-",
            "Delivery Date": item.deliveryDate
            ? new Date(item.deliveryDate).toLocaleDateString("id-ID")
            : "-",
            "Model Code": item.modelCode ?? "",
            "Claim Date": item.claimDate
            ? new Date(item.claimDate).toLocaleDateString("id-ID")
            : "-",
            "Create Date": item.createDate
            ? new Date(item.createDate).toLocaleDateString("id-ID")
            : "-",
            "Status Code": item.status ?? "",
            "Status Desc": item.statusDesc ?? "",
            "Dealer Code": item.epCodeDealer ?? "",
            "Claim No": item.claimNo ?? "",
            "Dealer Name": item.companyName ?? "",
            "Punctual": item.punctualFlag ? "✔️" : "❌",
            "KM": item.km ?? "",
            "Program Name": item.programName ?? "",
            "Service No": item.serviceNo ?? "",
            "Extended Warranty": item.extendedWarranty ? "✔️" : "❌",
        }));

        // 🔹 Convert ke worksheet
        const worksheet = XLSX.utils.json_to_sheet(exportData);

        // 🔹 Buat workbook baru
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "History Claim");

        // 🔹 Convert ke file Excel & simpan
        const buffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const blob = new Blob([buffer], { type: "application/octet-stream" });
        saveAs(blob, `History_Claim_${vin}_${new Date().toISOString().slice(0, 10)}.xlsx`);
    };

    
    const [isLoadingGetData, setisLoadingGetData] = useState(false);
    const openEditModal = async (data) => {
       try{
            setisLoadingGetData(true);
            setSelectedData(data);// Dispatch action untuk fetch detail
            await dispatch(fetchReminderDetail(data.rep_order_no)).unwrap();
            setActiveClaimNo(data.rep_order_no);

            //GET FILE PENDUKUNG
            const responses = await axios.get(
                `${API_URL}/getFilePendukung?nomor=${data.rep_order_no}`
            );

            if (responses.status === 200) {
                setDatapendukung(responses.data.data);

            } else {
                setisLoadingGetData(false);
                Toast.fire({
                    icon: "error",
                    title: responses.error,
                });
            }

            setDataVehiclesList("");
            if (data.warrtype === ''){
                try {
                    const response = await axios.get(
                        `${API_URL}/getVehiclesList?vin=${data.vin}&emailuser=${localStorage.getItem('userEmail')}`
                    );

                    if (response.status === 200) {
                        const datas = response.data.data.resultVehiclesList || [];

                        let claimType = "";

                        if (datas[0].claimType === "PLC") {
                            claimType = "PL";
                        } else if (datas[0].claimType === "FPC") {
                            claimType = "FP";
                        } else if (datas[0].claimType === "FLC") {
                            claimType = "FL";
                        } else {
                            claimType = "";
                        }

                        setSelectedData(prev => ({ ...prev, warrtype: claimType }));

                        if (datas[0].deliveryDate) {
                            setSelectedData(prev => ({ ...prev, delivery_date: datas[0].deliveryDate }));
                        }
                    } else {
                        setisLoadingGetData(false);
                        Toast.fire({
                            icon: "success",
                            title: response.error,
                        });
                    }
                } catch (error) {
                    setisLoadingGetData(false);
                    console.error("Gagal fetch :", error);
                    Toast.fire({
                            icon: "error",
                            title: error,
                        });
                }
            }

            
            setIsEditModalOpen(true);
            setBase64Files({ [data.rep_order_no]: data.filependukung });
            setisLoadingGetData(false);
        } catch (error) {
            setisLoadingGetData(false);
            console.error('Failed to fetch detail:', error);
            Toast.fire({
                icon: "error",
                title: "Gagal memuat detail data"
            });
      }
    };

    const handleOpenDetail = async (data) => {
        try {
            console.log("Trigger dari Navbar:", data);

            // simpen data yang diklik
            setSelectedData(data);

            // buka modal
            setIsEditModalOpen(true);

            // kalau mau fetch detail ke backend juga bisa di sini:
            // await dispatch(fetchReminderDetail(data.rep_order_no)).unwrap();

        } catch (error) {
            console.error("Gagal buka detail:", error);
        }
    };


    const [isLoadingEventLog, setIsLoadingEventLog] = useState(false);
    

    const openEventLogModal = async (data) => {
        try{
             setSelectedData(data);
             setIsLoadingEventLog(true);
             
             if (!data.claim_process_no) {
                console.error('Failed to fetch Event Log:', error);
                Toast.fire({
                    icon: "error",
                    title: "Event Log Kosong !"
                });
                setIsLoadingEventLog(false);
             }

             const email = localStorage.getItem('userEmail');

             const item = {
                    nomor: data.claim_process_no,
                    emailuser: email,
                };

             const result = await dispatch(fetchEventLog(item)).unwrap(); // ← hasilnya ada di sini
             setIsLoadingEventLog(false);
             setEventlogData(result);// Dispatch action untuk fetch detail
             setActiveClaimNo(data.rep_order_no);
             setIsEventLogModalOpen(true);
         } catch (error) {
             console.error('Failed to fetch Event Log:', error);
             Toast.fire({
                 icon: "error",
                 title: "Gagal memuat Event Log"
             });
       }
    };

    const openUploadModal = async (data) => {
        try{
            setSelectedData(data);// Dispatch action untuk fetch detail
            await dispatch(fetchReminderDetail(data.rep_order_no)).unwrap();
            setActiveClaimNo(data.rep_order_no);
            setIsUploadFileModalOpen(true);
            setBase64Files({ [data.rep_order_no]: data.filependukung });
        } catch (error) {
            console.error('Failed to fetch detail:', error);
            Toast.fire({
                icon: "error",
                title: "Gagal memuat detail data"
            });
      }
    };

    const openExportModal = async (data) => {
        setIsExportModalOpen(true);
    };


    // Tambahkan fungsi ini di komponen RemindersReport
    const mapJenisToCategory = (jenis) => {
        switch(jenis) {
        case 1: return 'parts';
        case 3: return 'jasa';
        case 2: return 'opl'; // pekerjaan luar
        case 4: return 'bahan';
        default: return 'other';
        }
    };    
    
    // Fungsi untuk mengelompokkan data berdasarkan jenis dan menghitung total
    const groupDataByCategory = (data) => {
        // Tambahkan pengecekan null/undefined
        if (!data || !Array.isArray(data)) {
        return {
            parts: [],
            jasa: [],
            opl: [],
            bahan: [],
            other: []
        };
        }
    
        const grouped = {
        parts: [],
        jasa: [],
        opl: [],
        bahan: [],
        other: []
        };
    
        // Kelompokkan data dan hitung total
        data.forEach(item => {
        const category = mapJenisToCategory(item.index_cat);
        grouped[category].push(item);
        });
    
        return grouped;
    };

    // const closeEditModal = () => setIsEditModalOpen(false);
    const closeEditModal = () => {
    // Reset semua checkbox (unselect all)
    setSelectedItems([]); 

    // Tutup modal
    setIsEditModalOpen(false);
    };

    const closeUploadFileModal = () => {
    // Reset semua checkbox (unselect all)
    setSelectedItems([]); 

    // Tutup modal
    setIsUploadFileModalOpen(false);
    };

    const closeExportModal = () => {
    // Tutup modal
    setIsExportModalOpen(false);
    };
    
    const closeEventLogModal = () => setIsEventLogModalOpen(false);
    // const closeUploadFileModal = () => setIsUploadFileModalOpen(false);

    const [submitButton, setSubmitButton] = useState(false);
    const [submitClaimButton, setSubmitClaimButton] = useState(false);
    const [updatePaperlessButton, setupdatePaperlessButton] = useState(false);
    const [sendPaperlessButton, setsendPaperlessButton] = useState(false);
    
    const [selectedParts, setSelectedParts] = useState([]); // dari tab "Sparepart"
    const [selectedJasa, setSelectedJasa] = useState([]);
    const [selectedOPL, setSelectedOPL] = useState([]);
    const [selectedBahan, setSelectedBahan] = useState([]);
    
    const { customer_reminders, error, isLoading} = useSelector((state) => state.customerReminders);

    const formatCurrency = (value) => {
        return new Intl.NumberFormat('id-ID', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
          useGrouping: true
        }).format(value ?? 0);
      };

    const formatCurrencyInput = (num) => {
        return (num || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    };
      
    //console.log("Email user:", localStorage.getItem('grup'));
    const [isLoadingUpdate, setIsLoadingUpdate] = useState(false);
    const [isLoadingUpdatePaperless, setIsLoadingUpdatePaperless] = useState(false);
    const [isLoadingSendPaperless, setIsLoadingSendPaperless] = useState(false);
    
    const handleSubmit = () => {
        // 🧩 Cegah klik ganda
        if (isLoadingUpdate) return;

        // 🧩 Validasi data utama
        if (!selectedData || !selectedData.rep_order_no) {
            Toast.fire({ icon: "warning", title: "Data WO tidak ditemukan." });
            return;
        }

        const nomorwo = selectedData.rep_order_no;
        const nomor = selectedData.claim_no;
        const odmeter = odometer || 0;
        const tanggal = selectedData.updated_at || new Date();
        const tglbstk = selectedData.delivery_date || null;
        const warrtype = selectedData.warrtype || "";
        const specialclaimflag = selectedData.specialclaimflag || "";
        const email = localStorage.getItem('userEmail');

        if (!warrtype) {
            Toast.fire({
                icon: "error",
                title: `Warranty ${nomorwo} belum diisi.`,
            });
            return;
        }

        // 🚫 Cegah re-claim
        const status = (selectedData.statusclaim || "").toLowerCase();
        if (status.includes("approved") || status.includes("claim sudah diajukan")) {
            Toast.fire({
                icon: "error",
                title: `Nomor WO ${nomorwo} sudah ${selectedData.statusclaim} dan tidak bisa di-update kembali.`,
            });
            return;
        }

        // 🧾 Filter detail per kategori
        const detailParts = (selectedParts || []).filter(i => i.rep_order_no === nomorwo);
        const detailJasa = (selectedJasa || []).filter(i => i.rep_order_no === nomorwo);
        const detailOPL = (selectedOPL || []).filter(i => i.rep_order_no === nomorwo);
        const detailBahan = (selectedBahan || []).filter(i => i.rep_order_no === nomorwo);

        // 💰 Hitung subtotal
        const calcSubtotal = (items) =>
            items.reduce((sum, item) => sum + Number(item.total_amount || 0), 0);

        const subtotalParts = calcSubtotal(detailParts);
        const subtotalJasa = calcSubtotal(detailJasa);
        const subtotalOPL = calcSubtotal(detailOPL);
        const subtotalBahan = calcSubtotal(detailBahan);
        // const dpp = subtotalParts + subtotalJasa + subtotalOPL + subtotalBahan;
        // const ppn = Math.round(dpp * 0.11);
        // const grandTotal = dpp + ppn;

        // Cek apakah semuanya 0
        const allZero = 
            subtotalParts === 0 &&
            subtotalJasa === 0 &&
            subtotalOPL === 0 &&
            subtotalBahan === 0;

        let dpp = 0;
        let ppn = 0;
        let grandTotal = 0;

        if (!allZero) {
            dpp = subtotalParts + subtotalJasa + subtotalOPL + subtotalBahan;
            ppn = Math.round(dpp * 0.11);
            grandTotal = dpp + ppn;
        }

        // 📎 File pendukung (loop otomatis)
        // const files = {};
        // for (let i = 1; i <= 5; i++) {
        //     const key = `filependukung${i}`;
        //     const fileData = base64Files[nomorwo]?.[key] || {};
        //     files[`filependukung${i}`] = fileData.base64 || "";
        //     files[`filename${i}`] = fileData.filename || "";
        //     files[`mimetype${i}`] = fileData.mimeType || "";
        // }

        const files = {};
        for (let i = 1; i <= 5; i++) {
            const key = `pendukung${i}`; // ← INI YANG BENAR
            const fileData = base64Files[nomorwo]?.[key] || {};
            files[`filependukung${i}`] = fileData.base64 || "";
            files[`filename${i}`] = fileData.filename || "";
            files[`mimetype${i}`] = fileData.mimeType || "";
        }

        // 🧱 Susun payload
        const payload = {
            emailuser: email,
            nomorwo,
            tanggal_estimasi: tanggal,
            warrtype,
            specialclaimflag,
            part: subtotalParts,
            jasa: subtotalJasa,
            opl: subtotalOPL,
            bahan: subtotalBahan,
            dpp,
            ppn,
            grandTotal,
            odmeter,
            tglbstk,
            ...files,
            detail: {
                parts: detailParts.map(item => ({
                    suplyslip_no: item.suplyslip_no,
                    kode_referensi: item.item_code,
                    kode_upselling: item.item_code_upselling,
                    qty: Number(item.qty),
                    harga: Number(item.item_amount),
                    subtotal: Number(item.total_amount),
                })),
                jasa: detailJasa.map(item => ({
                    suplyslip_no: item.suplyslip_no,
                    kode_referensi: item.item_code,
                    qty: Number(item.qty),
                    harga: Number(item.item_amount),
                    subtotal: Number(item.total_amount),
                })),
                opl: [...detailOPL, ...detailBahan].map(item => ({
                    suplyslip_no: item.suplyslip_no,
                    kode_referensi: item.item_code,
                    qty: Number(item.qty),
                    harga: Number(item.item_amount),
                    subtotal: Number(item.total_amount),
                })),
            },
        };

        console.log("📦 Payload dikirim:", payload);

        // 🚀 Kirim ke backend
        setIsLoadingUpdate(true);
        setSubmitButton(true);
        dispatch(storeCustomerReminders([payload])) // tetap array satu elemen
            .unwrap()
            .then((response) => {
                setIsLoadingUpdate(false);
                console.log("✅ handleSubmit selesai:", response);

                if (response.success) {
                    Toast.fire({
                        icon: "success",
                        title: response.message,
                    });
                    //initFilters();
                    //dispatch(fetchCustomerReminders()).unwrap();
                    fetchData(1);
                } else {
                    Toast.fire({
                        icon: "error",
                        title: response.message || "Gagal memperbarui data.",
                    });
                }

                setSubmitButton(false);
            })
            .catch((err) => {
                setIsLoadingUpdate(false);
                console.error("❌ handleSubmit error:", err);
                Toast.fire({
                    icon: "error",
                    title: "Terjadi kesalahan saat kirim data.",
                });
                setSubmitButton(false);
            });
    };

    const [isLoadingClaim, setIsLoadingClaim] = useState(false);

    const handleSendClaim = () => {
        var status = false;
        if (isLoadingClaim) return;
        // ✅ Validasi awal: belum ada yang dicentang
        if (!selectedItems || selectedItems.length === 0) {
            Toast.fire({
                icon: "warning",
                title: "Silakan pilih data terlebih dahulu sebelum kirim claim."
            });
            return;
        }

        const result = selectedItems
            
            .filter(header => header.rep_order_no)
            .map((header) => {
                // if (!selectedData.warrtype) {
                //     Toast.fire({
                //         icon: "error",
                //         title: `Warranty ${selectedData.rep_order_no} Belum diisi !.`
                //     });
                //     return;
                // }
                const nomor = header.claim_no;
                const nomorwo = header.rep_order_no;
                const tanggal = header.updated_at;
                const warrtype = header.warrtype || '';
                const specialclaimflag = header.specialclaimflag || 0;
                const odmeter = header.km || 0;
                const statusclaims = header.statusclaim;

                // 🚫 Cek kalau status sudah approved atau sudah diklaim
                if (statusclaims === "Approved" || statusclaims === "Claim sudah diajukan") {
                    Toast.fire({
                        icon: "error",
                        title: `Nomor WO ${nomorwo} sudah ${statusclaims}, tidak bisa melakukan claim kembali`
                    });
                    // Hentikan proses claim
                    status = true;
                }
                
                const detailParts = selectedParts.filter(item => item.rep_order_no === nomorwo);
                const detailJasa = selectedJasa.filter(item => item.rep_order_no === nomorwo);
                const detailOPL = selectedOPL.filter(item => item.rep_order_no === nomorwo);
                const detailBahan = selectedBahan.filter(item => item.rep_order_no === nomorwo);
    
                const getSubtotal = (items) => {
                    const unique = items.filter((item, index, self) =>
                        index === self.findIndex(i => i.item_code === item.item_code && i.rep_order_no === item.rep_order_no)
                    );
                    return unique.reduce((sum, item) => sum + Number(item.total_amount || 0), 0);
                };
    
                const subtotalParts = getSubtotal(detailParts);
                const subtotalJasa = getSubtotal(detailJasa);
                const subtotalOPL = getSubtotal(detailOPL);
                const subtotalBahan = getSubtotal(detailBahan);
    
                // const dpp = subtotalParts + subtotalJasa + subtotalOPL + subtotalBahan;
                // const ppn = dpp * 0.11;
                // const grandTotal = dpp + ppn;

                // Cek apakah semuanya 0
                const allZero = 
                    subtotalParts === 0 &&
                    subtotalJasa === 0 &&
                    subtotalOPL === 0 &&
                    subtotalBahan === 0;

                let dpp = 0;
                let ppn = 0;
                let grandTotal = 0;

                if (!allZero) {
                    dpp = subtotalParts + subtotalJasa + subtotalOPL + subtotalBahan;
                    ppn = Math.round(dpp * 0.11);
                    grandTotal = dpp + ppn;
                }

                const email = localStorage.getItem('userEmail');
                console.log("Email user:", email);

                return {
                    emailuser: email,
                    nomor_estimasi: nomor,
                    nomorwo: nomorwo,
                    tanggal_estimasi: tanggal,
                    warrtype: warrtype,
                    specialclaimflag: specialclaimflag,
                    part: subtotalParts,
                    jasa: subtotalJasa,
                    opl: subtotalOPL,
                    bahan: subtotalBahan,
                    odmeter:odmeter,
                    dpp,
                    ppn,
                    grandTotal,

                    filependukung1: base64Files[nomorwo]?.filependukung1?.base64 || '',
                    filename1: base64Files[nomorwo]?.filependukung1?.filename || '',
                    mimetype1 : base64Files[nomorwo]?.filependukung1?.mimeType || '',

                    filependukung2: base64Files[nomorwo]?.filependukung2?.base64 || '',
                    filename2: base64Files[nomorwo]?.filependukung2?.filename || '',
                    mimetype2 : base64Files[nomorwo]?.filependukung2?.mimeType || '',

                    filependukung3: base64Files[nomorwo]?.filependukung3?.base64 || '',
                    filename3: base64Files[nomorwo]?.filependukung3?.filename || '',
                    mimetype3 : base64Files[nomorwo]?.filependukung3?.mimeType || '',

                    filependukung4: base64Files[nomorwo]?.filependukung4?.base64 || '',
                    filename4: base64Files[nomorwo]?.filependukung4?.filename || '',
                    mimetype4 : base64Files[nomorwo]?.filependukung4?.mimeType || '',

                    filependukung5: base64Files[nomorwo]?.filependukung5?.base64 || '',
                    filename5: base64Files[nomorwo]?.filependukung5?.filename || '',
                    mimetype5 : base64Files[nomorwo]?.filependukung5?.mimeType || '',
                    detail: {
                        parts: detailParts.map(item => ({
                          suplyslip_no: item.suplyslip_no,
                          kode_referensi: item.item_code,
                          qty: Number(item.qty),
                          harga: Number(item.item_amount),
                          subtotal: Number(item.total_amount),
                        })),
                        jasa: detailJasa.map(item => ({
                          suplyslip_no: item.suplyslip_no,
                          kode_referensi: item.item_code,
                          qty: Number(item.qty),
                          harga: Number(item.item_amount),
                          subtotal: Number(item.total_amount),
                        })),
                        opl: [...detailOPL, ...detailBahan].map(item => ({
                          suplyslip_no: item.suplyslip_no,
                          kode_referensi: item.item_code,
                          qty: Number(item.qty),
                          harga: Number(item.item_amount),
                          subtotal: Number(item.total_amount),
                        })),
                      }
                };
            })

            if (status === true) {
                return;
            }
    
        //console.log('Hasil Kirim Claim:', result);
    
        setIsLoadingClaim(true);
        setSubmitClaimButton(true);
        dispatch(storeClaim(result))
            .unwrap()
            .then((response) => {
                setIsLoadingClaim(false);
    
                if (response.success) {
                    Toast.fire({
                        icon: "success",
                        title: response.message
                    });
    
                    // ⬅️ Auto refresh data list
                    //initFilters();
                    dispatch(fetchCustomerReminders()).unwrap(); // pastikan kamu punya fungsi ini
    
                } else {
                    Toast.fire({
                        icon: "error",
                        title: response.message
                    });
                }
    
                setSubmitClaimButton(false);
            })
            .catch((err) => {
                setIsLoadingClaim(false);
                console.error(err);
                setSubmitClaimButton(false);
            });
    };

    const handleUpdatePaperless = () => {
        // 🧩 Cegah klik ganda
        if (isLoadingUpdatePaperless) return;

        // 🧩 Validasi data utama
        if (!selectedData || !selectedData.rep_order_no) {
            Toast.fire({ icon: "warning", title: "Data WO tidak ditemukan." });
            return;
        }

        const nomorwo = selectedData.rep_order_no;
        const twc_no = selectedData.twc_no;
        const email = localStorage.getItem('userEmail');

        // 🚫 Cegah re-claim
        const status = (selectedData.statusclaim || "").toLowerCase();
        if (status.includes("Belum Claim") || status.includes("Reject")) {
            Toast.fire({
                icon: "error",
                title: `Nomor WO ${nomorwo} yang belum Approved tidak bisa update Paperless.`,
            });
            return;
        }

        // 🧱 Ambil data file
        const fakturDms = base64Files[nomorwo]?.filefakturdms || {};
        const fakturPajak = base64Files[nomorwo]?.filefakturpajak || {};

        // 🧱 Susun payload
        const payload = {
            emailuser: email,
            nomorwo,
            twc_no,
            // File Faktur Dealer System
            filefakturdms: fakturDms.base64 || "",
            namafilefakturdms: fakturDms.filename || "",
            filefakturdms_mimetype: fakturDms.mimeType || "",
            // File Faktur Pajak
            filefakturpajak: fakturPajak.base64 || "",
            namafilefakturpajak: fakturPajak.filename || "",
            filefakturpajak_mimetype: fakturPajak.mimeType || "",
        };

        console.log("📦 Payload dikirim:", payload);

        //🚀 Kirim ke backend
        setIsLoadingUpdatePaperless(true);
        dispatch(storeUpdatePaperless([payload])) // tetap array satu elemen
            .unwrap()
            .then((response) => {
                setIsLoadingUpdatePaperless(false);
                console.log("✅ handleSubmit selesai:", response);

                if (response.success) {
                    Toast.fire({
                        icon: "success",
                        title: response.message,
                    });
                    //initFilters();
                    dispatch(fetchCustomerReminders()).unwrap();
                } else {
                    Toast.fire({
                        icon: "error",
                        title: response.message || "Gagal memperbarui data.",
                    });
                }

                setupdatePaperlessButton(false);
            })
            .catch((err) => {
                setIsLoadingUpdatePaperless(false);
                console.error("❌ handleSubmit error:", err);
                Toast.fire({
                    icon: "error",
                    title: "Terjadi kesalahan saat kirim data.",
                });
                setupdatePaperlessButton(false);
            });
    };

    const handleSendMFT = () => {
        // 🧩 Cegah klik ganda
        if (isLoadingSendPaperless) return;

        // 🧩 Validasi data utama
        if (!selectedData || !selectedData.rep_order_no) {
            Toast.fire({ icon: "warning", title: "Data WO tidak ditemukan." });
            return;
        }

        const nomorwo = selectedData.rep_order_no;
        const twc_no = selectedData.twc_no;
        const email = localStorage.getItem('userEmail');

        // 🚫 Cegah re-claim
        const status = (selectedData.statusclaim || "").toLowerCase();
        if (status.includes("Belum Claim") || status.includes("Reject")) {
            Toast.fire({
                icon: "error",
                title: `Nomor WO ${nomorwo} yang belum Approved tidak bisa update Paperless.`,
            });
            return;
        }

        // 🧱 Ambil data file
        const fakturDms = base64Files[nomorwo]?.filefakturdms || {};
        const fakturPajak = base64Files[nomorwo]?.filefakturpajak || {};

        // 🧱 Susun payload
        const payload = {
            emailuser: email,
            nomor_faktur: nomorwo,
            twc_no : twc_no,
            // File Faktur Dealer System
            filefakturdms: fakturDms.base64 || "",
            namafilefakturdms: fakturDms.filename || "",
            filefakturdms_mimetype: fakturDms.mimeType || "",
            // File Faktur Pajak
            filefakturpajak: fakturPajak.base64 || "",
            namafilefakturpajak: fakturPajak.filename || "",
            filefakturpajak_mimetype: fakturPajak.mimeType || "",
        };

        console.log("📦 Payload dikirim:", payload);

        //🚀 Kirim ke backend
        setIsLoadingSendPaperless(true);
        dispatch(storeSendPaperless([payload])) // tetap array satu elemen
            .unwrap()
            .then((response) => {
                setIsLoadingSendPaperless(false);
                console.log("✅ handleSubmit selesai:", response);

                if (response.success) {
                    Toast.fire({
                        icon: "success",
                        title: response.message,
                    });
                    //initFilters();
                    dispatch(fetchCustomerReminders()).unwrap();
                } else {
                    Toast.fire({
                        icon: "error",
                        title: response.message || "Gagal memperbarui data.",
                    });
                }

                setsendPaperlessButton(false);
            })
            .catch((err) => {
                setIsLoadingSendPaperless(false);
                console.error("❌ handleSubmit error:", err);
                Toast.fire({
                    icon: "error",
                    title: "Terjadi kesalahan saat kirim data.",
                });
                setsendPaperlessButton(false);
            });
    };
    

    const [stateSummary, setStateSummary] = useState({
        dpp: 0,
        ppn: 0,
        materai: 0,
        grandTotal: 0,
    });

    const handleHargaChange = (e, kodeReferensi, type, qty, nomorEstimasi) => {
        const value = e.target.value.replace(/[^0-9]/g, "");
        const numeric = Number(value || 0);
        const parsedQty = Number(qty || 0);
        const total_amount = numeric * parsedQty;
    
        // Ambil selected list berdasarkan tipe
        const selectedList = type === 'parts' ? selectedParts
                          : type === 'jasa' ? selectedJasa
                          : type === 'opl' ? selectedOPL
                          : type === 'bahan' ? selectedBahan
                          : [];
    
        // Cari apakah item yang sedang diedit ini termasuk yang dipilih (centang)
        const isSelected = selectedList.some(
            (item) => item.item_code === kodeReferensi && item.rep_order_no === nomorEstimasi
        );
    
        // Kalau gak dicentang, abaikan perubahan
        if (!isSelected) {
            console.log("Lewat karena tidak dicentang");
            return;
        }
    
        // Lanjut update partsData sesuai item yang diedit
        const updatedList = partsData[type].map((item) =>
            item.item_code === kodeReferensi && item.rep_order_no === nomorEstimasi
                ? { ...item, item_amount: numeric, total_amount }
                : item
        );
    
        setpartsData((prev) => ({
            ...prev,
            [type]: updatedList,
        }));
    };

    const handleUpSelling = async (checked, row) => {
        // Simpan kode lama sebelum diubah
        const kodeLama = row.item_code;

        const key = `${row.rep_order_no}-${row.suplyslip_no}-${kodeLama}`;

        // Update checkbox state
        setUpSellingParts(prev => ({
            ...prev,
            [key]: checked,
        }));

        if (!checked) return;

        try {
            const response = await axios.get(
                `${API_URL}/getkodeupselling?part=${kodeLama}&qty=${row.qty}`
            );

            const upsell = response.data.data;

            // Mapping nilai baru
            const newCode  = upsell.kodepartupselling;
            const newQty   = Number(upsell.qtyupselling || row.qty);
            const newPrice = Number(upsell.hargaupselling || row.item_amount);
            const newTotal = newPrice * newQty;

            // ============================
            // 🔥 UPDATE DATA DI TABEL PARTS
            // ============================
            setpartsData(prev => {
                const updated = (prev["parts"] || []).map(item =>
                    item.item_code === kodeLama &&
                    item.suplyslip_no === row.suplyslip_no &&
                    item.rep_order_no === row.rep_order_no
                        ? {
                            ...item,
                            item_code_upselling: newCode,
                            qty: newQty,
                            item_amount: newPrice,
                            total_amount: newTotal,
                        }
                        : item
                );

                return {
                    ...prev,
                    parts: updated
                };
            });

            // ============================
            // 🔥 UPDATE SELECTED PARTS
            // ============================
            setSelectedParts(prev =>
                (prev || []).map(item =>
                    item.item_code === kodeLama &&
                    item.suplyslip_no === row.suplyslip_no &&
                    item.rep_order_no === row.rep_order_no
                        ? {
                            ...item,
                            item_code_upselling: newCode,
                            qty: newQty,
                            item_amount: newPrice,
                            total_amount: newTotal,
                        }
                        : item
                )
            );
        } catch (err) {
            console.error(err);
            Toast.fire({
                icon: "error",
                title: "Gagal mendapatkan kode up selling",
            });
        }
    };




    const handleSubtotalChange = (e, kodeReferensi, type, nomorwo, suplyslip_no) => {
        const value = e.target.value.replace(/[^0-9]/g, "");
        const subtotalBaru = Number(value || 0);

        // 🔹 pilih list yang aktif (buat update selected list juga)
        const getSetterByType = () => {
            switch (type) {
            case "parts":
                return setSelectedParts;
            case "jasa":
                return setSelectedJasa;
            case "opl":
                return setSelectedOPL;
            case "bahan":
                return setSelectedBahan;
            default:
                return null;
            }
        };

        // 🔹 update data utama
        setpartsData((prev) => ({
            ...prev,
            [type]: (prev[type] || []).map((item) =>
            item.item_code === kodeReferensi && item.suplyslip_no === suplyslip_no && item.rep_order_no === nomorwo
                ? {
                    ...item,
                    total_amount: subtotalBaru,
                    item_amount:
                    Number(item.qty || 0) > 0
                        ? subtotalBaru / Number(item.qty)
                        : 0,
                }
                : item
            ),
        }));

        // 🔹 update data yang sudah dicentang (biar sinkron di selected list)
        const updateSelected = getSetterByType();
        if (updateSelected) {
            updateSelected((prev) =>
            (prev || []).map((item) =>
                item.item_code === kodeReferensi && item.suplyslip_no === suplyslip_no && item.rep_order_no === nomorwo
                ? {
                    ...item,
                    total_amount: subtotalBaru,
                    item_amount:
                        Number(item.qty || 0) > 0
                        ? subtotalBaru / Number(item.qty)
                        : 0,
                    }
                : item
            )
            );
        }
    };





    
    const parseCurrency = (str) => {
        return Number(str.replace(/[^0-9,-]+/g, '').replace(',', '.'));
    };

    const getSelectedSubtotal = (tabName, claimNo) => {
        let selected = [];
    
        if (tabName === "parts") selected = selectedParts;
        else if (tabName === "jasa") selected = selectedJasa;
        else if (tabName === "opl") selected = selectedOPL;
        else if (tabName === "bahan") selected = selectedBahan;
    
        // Ambil hanya yang sesuai claimNo saat ini
        const filtered = selected.filter(item => item.rep_order_no === claimNo);
    
        // Filter duplikat berdasarkan item_code + claim_no
        const uniqueItems = filtered.filter((item, index, self) => {
            return (
                index === self.findIndex(
                    (t) => t.item_code === item.item_code && t.suplyslip_no === item.suplyslip_no && t.rep_order_no === item.rep_order_no
                )
            );
        });
    
        return uniqueItems.reduce((total, item) => {
            const sub = parseFloat(item.total_amount || item.subtotal || 0);
            return total + (isNaN(sub) ? 0 : sub);
        }, 0);
    };

    
    const [partsData, setpartsData] = useState({
        parts: [],
        jasa: [],
        opl: [],
        bahan: []
    });

   // ================================
    // 1️⃣ Set data & preselected saat modal edit dibuka
    // ================================
    useEffect(() => {
        if (isEditModalOpen) {
            const grouped = groupDataByCategory(detailData);
            setpartsData(grouped);

            // Ambil data yang dicentang sebelumnya per kategori
            const preselectedParts = detailData.filter(row => row.item_cat === 'parts' && row.claim);
            const preselectedBahan = detailData.filter(row => row.item_cat === 'bahan' && row.claim);
            const preselectedOpl   = detailData.filter(row => row.item_cat === 'opl'   && row.claim);
            const preselectedJasa  = detailData.filter(row => row.item_cat === 'jasa'  && row.claim);

            setOdometer(selectedData?.km ?? '');

            // Set preselected untuk masing-masing kategori
            setSelectedParts(preselectedParts);
            setSelectedBahan(preselectedBahan);
            setSelectedOPL(preselectedOpl);
            setSelectedJasa(preselectedJasa);
        }
    }, [isEditModalOpen, detailData, stateSummary.uangMuka, stateSummary.materai]);

    // ================================
    // 2️⃣ Sinkronisasi otomatis semua tab dengan partsData
    // ================================
    useEffect(() => {
        const syncSelectedList = (selectedList, dataList) =>
            selectedList.map((sel) => {
                const found = dataList.find(
                    (x) =>
                        x.item_code === sel.item_code &&
                        x.rep_order_no === sel.rep_order_no
                );
                return found
                    ? {
                        ...sel,
                        total_amount: found.total_amount,
                        item_amount: found.item_amount,
                        qty: found.qty,
                    }
                    : sel;
            });

        // Jalankan sinkronisasi untuk semua kategori
        setSelectedParts((prev) => syncSelectedList(prev, partsData.parts || []));
        setSelectedJasa((prev) => syncSelectedList(prev, partsData.jasa || []));
        setSelectedOPL((prev) => syncSelectedList(prev, partsData.opl || []));
        setSelectedBahan((prev) => syncSelectedList(prev, partsData.bahan || []));
    }, [partsData]);
    
    const [activeClaimNo, setActiveClaimNo] = useState(null);

    const [files, setFiles] = useState({});

    const [base64Files, setBase64Files] = useState({});
    const [previewBase64, setPreviewBase64] = useState(null);

    //-------------------------------------------------------------------------------------------------------------------------------------
    //Detail Claim WO
    //-------------------------------------------------------------------------------------------------------------------------------------
    const renderEditModal = () => {
        
            const handleFileAdditionalChange = (e, claimNo, nomor) => {
                const MAX_FILES = 5;
                const file = e.target.files[0];
                if (!file) return;

                // PASTIKAN nomor = angka 1-5
                nomor = parseInt(nomor);

                // ============================
                // 1. Validasi jumlah file
                // ============================
                const fileFields = [
                    "namafilependukung1",
                    "namafilependukung2",
                    "namafilependukung3",
                    "namafilependukung4",
                    "namafilependukung5",
                ];

                const totalUploaded = fileFields.filter(
                    (f) => Datapendukung?.[f] && Datapendukung[f] !== ""
                ).length;

                const isReplacing = !!Datapendukung?.[`namafilependukung${nomor}`];

                if (!isReplacing && totalUploaded >= MAX_FILES) {
                    Toast.fire({
                        icon: "warning",
                        title: `Maksimal ${MAX_FILES} file boleh di-upload.`,
                    });
                    return;
                }

                // ============================
                // 2. Validasi ukuran file
                // ============================
                if (file.size > 3 * 1024 * 1024) {
                    Toast.fire({
                        icon: "error",
                        title: "Ukuran file maksimal 3MB",
                    });
                    return;
                }

                // ============================
                // 3. Convert ke Base64
                // ============================
                const reader = new FileReader();

                reader.onload = () => {
                    const base64Raw = reader.result.split(",")[1];
                    const fileName = file.name;
                    const ext = fileName.split(".").pop().toLowerCase();

                    let mimeType = "application/octet-stream";
                    if (ext === "jpg" || ext === "jpeg") mimeType = "image/jpeg";
                    if (ext === "png") mimeType = "image/png";
                    if (ext === "pdf") mimeType = "application/pdf";

                    const base64Full = `data:${mimeType};base64,${base64Raw}`;

                    // SIMPAN KE BASE64FILES
                    setBase64Files((prev) => ({
                        ...prev,
                        [claimNo]: {
                            ...(prev[claimNo] || {}),
                            [`pendukung${nomor}`]: {
                                base64: base64Raw,
                                base64Full,
                                filename: fileName,
                                mimeType,
                            },
                        },
                    }));

                    // UPDATE KE DATAPENDUKUNG
                    setDatapendukung((prev) => ({
                        ...prev,
                        [`namafilependukung${nomor}`]: fileName,
                        [`filependukung${nomor}`]: base64Raw,
                        [`mimetype${nomor}`]: mimeType,
                    }));
                };

                reader.readAsDataURL(file);
            };


        
            const handlePreviewFile = (claimNo, type, index) => {
                // Ambil data base64 dari upload baru atau data lama
                const fileObj =
                    base64Files[claimNo]?.[`filependukung${index}`] ||
                    Datapendukung?.[`filependukung${index}`];

                if (!fileObj) return;

                // Ambil base64 dan nama file
                const base64 = fileObj.base64 || fileObj;
                const filename = fileObj.filename || '';
                const ext = filename.split('.').pop()?.toLowerCase() || '';

                // Tentukan mime type berdasarkan ekstensi
                let mimeType = 'application/octet-stream';
                if (['jpg', 'jpeg'].includes(ext)) mimeType = 'image/jpeg';
                else if (ext === 'png') mimeType = 'image/png';
                else if (ext === 'pdf') mimeType = 'application/pdf';
                else mimeType = type;

                // Tambahkan prefix data base64 jika belum ada
                const base64WithPrefix = base64.startsWith('data:')
                    ? base64
                    : `data:${mimeType};base64,${base64}`;

                // Kirim ke state preview
                setPreviewBase64({
                    src: base64WithPrefix,
                    mime: mimeType,
                });
            };


        return (
            <>
            <Modal isOpen={isEditModalOpen} onClose={closeEditModal} title={'Detail Work Order'} modalId={'Detail Work Order'}>
                {/* <form onSubmit={handleSubmit}> */}
                    <div className="row g-6">
                        <div className="row g-3 form-section">

                            <div className="col-md-6">
                                <label className="form-label">Nomor WO</label>
                                <input
                                type="text"
                                className="form-control input-flat"
                                value={selectedData?.rep_order_no ?? '-'}
                                readOnly
                                />
                            </div>

                            <div className="col-md-6">
                                <label className="form-label">Tanggal WO</label>
                                <input
                                type="text"
                                className="form-control input-flat"
                                value={selectedData?.repair_date ? moment(selectedData.repair_date).format('DD/MM/YYYY') : '-'}
                                readOnly
                                />
                            </div>

                            <div className="col-md-6">
                                <label className="form-label">Nomor Rangka</label>
                                <input
                                type="text"
                                className="form-control input-flat"
                                value={selectedData?.vin ?? '-'}
                                readOnly
                                />
                            </div>

                            <div className="col-md-6">
                                <label className="form-label">Nomor Claim</label>
                                <input
                                type="text"
                                className="form-control input-flat"
                                value={selectedData?.claim_no ?? '-'}
                                readOnly
                                />
                            </div>

                            <div className="col-md-6">
                                <label className="form-label">Nomor Proses</label>
                                <input
                                type="text"
                                className="form-control input-flat"
                                value={selectedData?.claim_process_no ?? '-'}
                                readOnly
                                />
                            </div>

                            <div className="col-md-6">
                                <label className="form-label required">Jenis Warranty</label>
                                <select
                                className="form-select input-flat"
                                value={selectedData?.warrtype || ''}
                                onChange={(e) => setSelectedData({ ...selectedData, warrtype: e.target.value })}
                                >
                                <option value="">-- Pilih Warranty --</option>
                                <option value="FL">FLC</option>
                                <option value="PL">PLC</option>
                                <option value="FP">FPC</option>
                                </select>
                            </div>

                            <div className="col-md-6">
                                <label className="form-label">Tanggal BSTK</label>
                                <input
                                    type="date"
                                    className="form-control input-flat"
                                    value={
                                    selectedData?.delivery_date
                                        ? moment(selectedData.delivery_date).format('YYYY-MM-DD') // format wajib buat input[type=date]
                                        : ''
                                    }
                                    onChange={(e) => {
                                    const newDate = e.target.value;
                                    setSelectedData((prev) => ({
                                        ...prev,
                                        delivery_date: newDate, // simpan tanggal baru
                                    }));
                                    }}
                                />
                            </div>

                            <div className="col-md-6">
                                <label className="form-label required">Odometer</label>
                                <input
                                type="text"
                                className="form-control input-flat text-end bg-white"
                                value={odometer}
                                onChange={(e) => setOdometer(e.target.value)}
                                />
                            </div>

                            <div className="col-md-6">
                                <div className="form-check">
                                <input
                                    type="checkbox"
                                    id="specialclaimflag"
                                    className="form-check-input"
                                    checked={selectedData?.specialclaimflag === true}
                                    onChange={(e) =>
                                    setSelectedData({
                                        ...selectedData,
                                        specialclaimflag: e.target.checked,
                                    })
                                    }
                                />
                                <label className="form-check-label fw-semibold" htmlFor="specialclaimflag">
                                    Special Claim
                                </label>
                                </div>
                            </div>

                            {selectedData?.statusclaim === "Reject" && (
                                <div className="col-12" 
                                        style={{
                                                margin: '8px',
                                                }}>
                                <div className="card shadow-sm border-danger mt-2">
                                    <div className="card-header bg-danger text-white py-2">
                                    <p className="m-0 fw-semibold">Reject Message</p>
                                    </div>
                                    <div className="card-body">
                                    <p className="m-0 text-muted">{selectedData?.error_status}</p>
                                    </div>
                                </div>
                                </div>
                            )}

                            {(selectedData?.statusclaim === "Approved" || selectedData?.statusclaim === "Send MFT") && (
                                <div className="col-12"
                                            style={{
                                                margin: '8px',
                                                }}
                                >
                                <div className="card shadow-sm border-success mt-2">
                                    <div className="card-header bg-success text-white py-2">
                                    <p className="m-0 fw-semibold">Approved</p>
                                    </div>
                                    <div className="card-body">
                                    <p className="m-0 text-muted">
                                        Nomor Faktur Otomatis : {selectedData?.noinvoice}
                                    </p>
                                    </div>
                                </div>
                                </div>
                            )}
                        </div>


                        <div className='col-md-12'>
                            <div className='card'>
                                <div className='card-header'>
                                    <p className='m-0 p-0 fw-semibold'>Detail Items</p>
                                </div>
                                <div className="container mt-4">
                                <Tabs defaultActiveKey="summary" id="detail-tabs" className="mb-3">

                                    {/* Tab Summary */}
                                    <Tab eventKey="summary" title="Summary">
                                        <div className="row mt-4">
                                            {/* Kolom Kiri */}
                                            <div className="col-md-6">
                                            {[
                                                { label: "Total Sparepart", key: "parts" },
                                                { label: "Total OPL", key: "opl" },
                                                { label: "Total Jasa", key: "jasa" },
                                                { label: "Total Bahan", key: "bahan" },
                                                { label: "Total", key: "total" },
                                            ].map((item, index) => (
                                                <div className="mb-2" key={index}>
                                                <label className="fw-semibold">{item.label}</label>
                                                <input
                                                    type="text"
                                                    id={`summary-${item.key}`}
                                                    style={{
                                                        flex: 1,
                                                        padding: '4px 10px',
                                                        backgroundColor: '#f1f1f1',
                                                        borderBottom: '2px solid #0d3b66',
                                                        textAlign: 'right',
                                                        fontWeight: 'bold',
                                                        color: '#333',
                                                        fontSize: '0.9rem',
                                                        borderTopRightRadius: '4px',
                                                        borderBottomRightRadius: '4px',
                                                        }}
                                                    className="form-control form-control-sm text-end"
                                                    value={formatCurrency(
                                                    item.key === "total"
                                                        ? getSelectedSubtotal("parts", activeClaimNo) +
                                                        getSelectedSubtotal("opl", activeClaimNo) +
                                                        getSelectedSubtotal("jasa", activeClaimNo) +
                                                        getSelectedSubtotal("bahan", activeClaimNo) 
                                                        : getSelectedSubtotal(item.key, activeClaimNo)
                                                    )}
                                                    readOnly
                                                />
                                                </div>
                                            ))}
                                            </div>

                                            {/* Kolom Kanan */}
                                            <div className="col-md-6">
                                            {[
                                                { label: "DPP", key: "dpp", readOnly: true },
                                                { label: "PPN", key: "ppn", readOnly: true },
                                                { label: "Grand Total", key: "grandTotal", readOnly: true },
                                            ].map((item, index) => (
                                                <div className="mb-2" key={index}>
                                                <label className="fw-semibold">{item.label}</label>
                                                <input
                                                    type="text"
                                                    id={`summary-${item.key}`} 
                                                    style={{
                                                        flex: 1,
                                                        padding: '4px 10px',
                                                        backgroundColor: '#f1f1f1',
                                                        borderBottom: '2px solid #0d3b66',
                                                        textAlign: 'right',
                                                        fontWeight: 'bold',
                                                        color: '#333',
                                                        fontSize: '0.9rem',
                                                        borderTopRightRadius: '4px',
                                                        borderBottomRightRadius: '4px',
                                                        }}
                                                className="form-control form-control-sm text-end"
                                                    value={formatCurrency(
                                                        item.key === "dpp"
                                                            ? getSelectedSubtotal("parts", activeClaimNo) +
                                                            getSelectedSubtotal("opl", activeClaimNo) +
                                                            getSelectedSubtotal("jasa", activeClaimNo) +
                                                            getSelectedSubtotal("bahan", activeClaimNo)
                                                            : item.key === "ppn"
                                                            ? (getSelectedSubtotal("parts", activeClaimNo) +
                                                            getSelectedSubtotal("opl", activeClaimNo) +
                                                            getSelectedSubtotal("jasa", activeClaimNo) +
                                                            getSelectedSubtotal("bahan", activeClaimNo)) * 0.11
                                                            : item.key === "grandTotal"
                                                            ? ((getSelectedSubtotal("parts", activeClaimNo) +
                                                            getSelectedSubtotal("opl", activeClaimNo) +
                                                            getSelectedSubtotal("jasa", activeClaimNo) +
                                                            getSelectedSubtotal("bahan", activeClaimNo)) * 0.11) + (getSelectedSubtotal("parts", activeClaimNo) +
                                                            getSelectedSubtotal("opl", activeClaimNo) +
                                                            getSelectedSubtotal("jasa", activeClaimNo) +
                                                            getSelectedSubtotal("bahan", activeClaimNo))
                                                            : getSelectedSubtotal(item.key)
                                                        )}
                                                    onChange={(e) =>
                                                    item.editable &&
                                                    setStateSummary((prev) => ({
                                                        ...prev,
                                                        [item.key]: parseCurrency(e.target.value),
                                                    }))
                                                    }
                                                    readOnly={item.readOnly}
                                                />
                                                </div>
                                            ))}
                                            </div>
                                        </div>
                                    </Tab>


                                    {/* Tab Sparepart */}
                                    <Tab eventKey="parts" title="Sparepart">
                                        <>
                                        <DataTable
                                            value={partsData.parts}
                                            showGridlines
                                            dataKey={(row) => `${row.rep_order_no}-${row.suplyslip_no}-${row.item_code}`}
                                            emptyMessage="Tidak ada data sparepart."
                                            className="fs-12"
                                            selection={selectedParts} // ⬅️ bind state selectedParts
                                            onSelectionChange={(e) => setSelectedParts(e.value)} // ⬅️ update saat checkbox diubah
                                        >
                                            <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} />
                                            <Column header="No Pembebanan" body={(row) => isLoading ? <Skeleton /> : (row?.suplyslip_no ?? '')} />
                                            <Column header="Kode" body={(row) => isLoading ? <Skeleton /> : (row?.item_code ?? '')} />
                                            <Column header="Kode Upselling" body={(row) => isLoading ? <Skeleton /> : (row?.item_code_upselling ?? '')} />
                                            <Column header="Nama Part" body={(row) => isLoading ? <Skeleton /> : (row?.item_name ?? '')} />
                                            <Column
                                                header="Up Selling"
                                                body={(row) => {
                                                    // pakai key stabil
                                                    const key = `${row.rep_order_no}-${row.suplyslip_no}-${row.item_code}`;

                                                    // jika item_code_upselling ada → centang default
                                                    const isUpsell = row.item_code_upselling && row.item_code_upselling !== "";

                                                    return (
                                                        <Checkbox
                                                            style={{ margin: "3px" }}
                                                            checked={ upSellingParts[key] ?? isUpsell }
                                                            //checked={ upSellingParts[key] ?? false }
                                                            onChange={(e) => handleUpSelling(e.checked, row)}
                                                        />
                                                    );
                                                }}
                                                style={{ width: "120px", textAlign: "center" }}
                                            />
                                            <Column header="Qty" body={(row) => isLoading ? <Skeleton /> : (row?.qty ?? '')} />
                                            <Column header="Harga" body={(row) => isLoading ? <Skeleton /> : (formatCurrency(row?.item_amount) ?? '')} />
                                            <Column
                                                header="Subtotal"
                                                style={{ width: '150px', textAlign: 'right' }}
                                                body={(row) => (
                                                    <input
                                                    type="text"
                                                    className="form-control form-control-sm text-end"
                                                    //defaultValue={formatCurrencyInput(row.total_amount)}
                                                    value={formatCurrencyInput(row.total_amount)}
                                                    style={{
                                                        flex: 1,
                                                        padding: '4px 10px',
                                                        backgroundColor: 'white',
                                                        borderBottom: '2px solid #0d3b66',
                                                        textAlign: 'right',
                                                        fontWeight: 'bold',
                                                        color: '#333',
                                                        fontSize: '0.9rem',
                                                        borderTopRightRadius: '4px',
                                                        borderBottomRightRadius: '4px',
                                                    }}
                                                    onChange={(e) =>
                                                        handleSubtotalChange(e, row.item_code, "parts", row.rep_order_no, row?.suplyslip_no)
                                                    }
                                                    // onBlur={(e) => {
                                                    //     // saat keluar fokus, format tampilannya
                                                    //     e.target.value = formatCurrencyInput(e.target.value);
                                                    // }}
                                                    onBlur={(e) => {
                                                        const formatted = formatCurrencyInput(e.target.value);
                                                        e.target.value = formatted;

                                                        handleSubtotalChange(
                                                            { target: { value: formatted.replace(/[^0-9]/g, "") } },
                                                            row.item_code,
                                                            "parts",
                                                            row.rep_order_no,
                                                            row?.suplyslip_no
                                                        );
                                                    }}
                                                    />
                                                )}
                                            />
                                        </DataTable>
                                        <hr />
                                        <div className="d-flex justify-content-end" style={{ maxWidth: '300px', marginTop: '10px' }}>
                                            <div style={{
                                                fontWeight: 500,
                                                color: '#000',
                                                minWidth: '90px',
                                                fontSize: '0.9rem',
                                            }}>
                                                Total Parts  
                                            </div>
                                            <div
                                                style={{
                                                flex: 1,
                                                padding: '4px 10px',
                                                backgroundColor: '#f1f1f1',
                                                borderBottom: '2px solid #0d3b66',
                                                textAlign: 'right',
                                                fontWeight: 'bold',
                                                color: '#333',
                                                fontSize: '0.9rem',
                                                borderTopRightRadius: '4px',
                                                borderBottomRightRadius: '4px',
                                                }}
                                            >
                                                {formatCurrency(getSelectedSubtotal("parts", activeClaimNo))}
                                            </div>
                                        </div>
                                        <br />
                                        </>
                                    </Tab>

                                    {/* Tab Jasa */} 
                                    <Tab eventKey="jasa" title="Jasa">
                                    <>
                                        <DataTable
                                        value={partsData.jasa}
                                        showGridlines
                                        dataKey={(row) => `${row.rep_order_no}-${row.suplyslip_no}-${row.item_code}`}
                                        emptyMessage="Tidak ada data jasa."
                                        className="fs-12"
                                        selection={selectedJasa}
                                        onSelectionChange={(e) => setSelectedJasa(e.value)}
                                        >
                                        <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} />
                                        <Column header="No WO" body={(row) => isLoading ? <Skeleton /> : (row?.suplyslip_no ?? '')} />
                                        <Column header="Kode" body={(row) => isLoading ? <Skeleton /> : (row?.item_code ?? '')} />
                                        <Column header="Nama Jasa" body={(row) => isLoading ? <Skeleton /> : (row?.item_name ?? '')} />
                                        <Column header="Qty" body={(row) => isLoading ? <Skeleton /> : (row?.qty ?? '')} />
                                        <Column header="Harga" body={(row) => isLoading ? <Skeleton /> : (formatCurrency(row?.item_amount) ?? '')} />

                                        {/* Subtotal editable */}
                                        <Column
                                            header="Subtotal"
                                            style={{ width: '150px', textAlign: 'right' }}
                                            body={(row) => (
                                                <input
                                                type="text"
                                                className="form-control form-control-sm text-end"
                                                defaultValue={formatCurrencyInput(row.total_amount)}
                                                style={{
                                                    flex: 1,
                                                    padding: '4px 10px',
                                                    backgroundColor: 'white',
                                                    borderBottom: '2px solid #0d3b66',
                                                    textAlign: 'right',
                                                    fontWeight: 'bold',
                                                    color: '#333',
                                                    fontSize: '0.9rem',
                                                    borderTopRightRadius: '4px',
                                                    borderBottomRightRadius: '4px',
                                                }}
                                                onChange={(e) =>
                                                    handleSubtotalChange(e, row.item_code, "jasa", row.rep_order_no, row.suplyslip_no)
                                                }
                                                // onBlur={(e) => {
                                                //     // saat keluar fokus, format tampilannya
                                                //     e.target.value = formatCurrencyInput(e.target.value);
                                                // }}
                                                onBlur={(e) => {
                                                    const formatted = formatCurrencyInput(e.target.value);
                                                    e.target.value = formatted;

                                                    handleSubtotalChange(
                                                        { target: { value: formatted.replace(/[^0-9]/g, "") } },
                                                        row.item_code,
                                                        "jasa",
                                                        row.rep_order_no,
                                                        row.suplyslip_no
                                                    );
                                                }}
                                                />
                                            )}
                                        />
                                        </DataTable>

                                        <hr />

                                        <div className="d-flex justify-content-end" style={{ maxWidth: '300px', marginTop: '10px' }}>
                                        <div style={{
                                            fontWeight: 500,
                                            color: '#000',
                                            minWidth: '90px',
                                            fontSize: '0.9rem',
                                        }}>
                                            Total Jasa
                                        </div>
                                        <div
                                            style={{
                                            flex: 1,
                                            padding: '4px 10px',
                                            backgroundColor: '#f1f1f1',
                                            borderBottom: '2px solid #0d3b66',
                                            textAlign: 'right',
                                            fontWeight: 'bold',
                                            color: '#333',
                                            fontSize: '0.9rem',
                                            borderTopRightRadius: '4px',
                                            borderBottomRightRadius: '4px',
                                            }}
                                        >
                                            {formatCurrency(getSelectedSubtotal("jasa", activeClaimNo))}
                                        </div>
                                        </div>
                                        <br />
                                    </>
                                    </Tab>

                                    {/* Tab Pekerjaan Luar */}
                                    <Tab eventKey="opl" title="Pekerjaan Luar">
                                        <>
                                        <DataTable
                                            value={partsData.opl}
                                            showGridlines
                                            dataKey={(row) => `${row.rep_order_no}-${row.suplyslip_no}-${row.item_code}`}
                                            emptyMessage="Tidak ada data pekerjaan luar."
                                            className="fs-12"
                                            selection={selectedOPL}
                                            onSelectionChange={(e) => setSelectedOPL(e.value)}
                                        >
                                            <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} />
                                            <Column header="No Order" body={(row) => isLoading ? <Skeleton /> : (row?.suplyslip_no ?? '')} />
                                            <Column header="Kode" body={(row) => isLoading ? <Skeleton /> : (row?.item_code ?? '')} />
                                            <Column header="Deskripsi" body={(row) => isLoading ? <Skeleton /> : (row?.item_name ?? '')} />
                                            <Column header="Qty" body={(row) => isLoading ? <Skeleton /> : (row?.qty ?? '')} />
                                            <Column header="Harga" body={(row) => isLoading ? <Skeleton /> : (formatCurrency(row?.item_amount) ?? '')} />

                                            {/* Subtotal editable */}
                                            <Column
                                                header="Subtotal"
                                                style={{ width: '150px', textAlign: 'right' }}
                                                body={(row) => (
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm text-end"
                                                    value={formatCurrencyInput(row.total_amount)}
                                                    style={{
                                                    flex: 1,
                                                    padding: '4px 10px',
                                                    backgroundColor: 'white',
                                                    borderBottom: '2px solid #0d3b66',
                                                    textAlign: 'right',
                                                    fontWeight: 'bold',
                                                    color: '#333',
                                                    fontSize: '0.9rem',
                                                    borderTopRightRadius: '4px',
                                                    borderBottomRightRadius: '4px',
                                                    }}
                                                    onChange={(e) =>
                                                    handleSubtotalChange(e, row.item_code, "opl", row.rep_order_no, row.suplyslip_no)
                                                    }
                                                    onBlur={(e) => {
                                                        const formatted = formatCurrencyInput(e.target.value);
                                                        e.target.value = formatted;

                                                        handleSubtotalChange(
                                                            { target: { value: formatted.replace(/[^0-9]/g, "") } },
                                                            row.item_code,
                                                            "opl",
                                                            row.rep_order_no,
                                                            row.suplyslip_no
                                                        );
                                                    }}
                                                />
                                                )}
                                            />
                                        </DataTable>
                                        <hr />
                                        <div className="d-flex justify-content-end" style={{ maxWidth: '300px', marginTop: '10px' }}>
                                            <div style={{
                                                fontWeight: 500,
                                                color: '#000',
                                                minWidth: '90px',
                                                fontSize: '0.9rem',
                                            }}>
                                                Total Pekerjaan Luar  
                                            </div>
                                            <div
                                                style={{
                                                flex: 1,
                                                padding: '4px 10px',
                                                backgroundColor: '#f1f1f1',
                                                borderBottom: '2px solid #0d3b66',
                                                textAlign: 'right',
                                                fontWeight: 'bold',
                                                color: '#333',
                                                fontSize: '0.9rem',
                                                borderTopRightRadius: '4px',
                                                borderBottomRightRadius: '4px',
                                                }}
                                            >
                                                {formatCurrency(getSelectedSubtotal("opl", activeClaimNo))}
                                            </div>
                                        </div>
                                        <br />
                                        </>
                                    </Tab>

                                    {/* Tab Bahan */}
                                    <Tab eventKey="bahan" title="Bahan">
                                        <>
                                        <DataTable
                                            value={partsData.bahan}
                                            showGridlines
                                            dataKey={(row) => `${row.rep_order_no}-${row.suplyslip_no}-${row.item_code}`}
                                            emptyMessage="Tidak ada data bahan."
                                            className="fs-12"
                                            selection={selectedBahan}
                                            onSelectionChange={(e) => setSelectedBahan(e.value)}
                                        >
                                            <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} />
                                            <Column header="No Pembebanan" body={(row) => isLoading ? <Skeleton /> : (row?.suplyslip_no ?? '')} />
                                            <Column header="Kode" body={(row) => isLoading ? <Skeleton /> : (row?.item_code ?? '')} />
                                            <Column header="Nama Bahan" body={(row) => isLoading ? <Skeleton /> : (row?.item_name ?? '')} />
                                            <Column header="Qty" body={(row) => isLoading ? <Skeleton /> : (row?.qty ?? '')} />
                                            <Column header="Harga" body={(row) => isLoading ? <Skeleton /> : (formatCurrency(row?.item_amount) ?? '')} />

                                            {/* Subtotal editable */}
                                            <Column
                                                header="Subtotal"
                                                style={{ width: '150px', textAlign: 'right' }}
                                                body={(row) => (
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm text-end"
                                                    value={formatCurrencyInput(row.total_amount)}
                                                    style={{
                                                    flex: 1,
                                                    padding: '4px 10px',
                                                    backgroundColor: 'white',
                                                    borderBottom: '2px solid #0d3b66',
                                                    textAlign: 'right',
                                                    fontWeight: 'bold',
                                                    color: '#333',
                                                    fontSize: '0.9rem',
                                                    borderTopRightRadius: '4px',
                                                    borderBottomRightRadius: '4px',
                                                    }}
                                                    onChange={(e) =>
                                                    handleSubtotalChange(e, row.item_code, "bahan", row.rep_order_no, row.suplyslip_no)
                                                    }
                                                    // onBlur={(e) => {
                                                    // e.target.value = formatCurrencyInput(e.target.value);
                                                    // }}
                                                    onBlur={(e) => {
                                                        const formatted = formatCurrencyInput(e.target.value);
                                                        e.target.value = formatted;

                                                        handleSubtotalChange(
                                                            { target: { value: formatted.replace(/[^0-9]/g, "") } },
                                                            row.item_code,
                                                            "bahan",
                                                            row.rep_order_no,
                                                            row.suplyslip_no
                                                        );
                                                    }}
                                                />
                                                )}
                                            />
                                        </DataTable>
                                        <hr />
                                        <div className="d-flex justify-content-end" style={{ maxWidth: '300px', marginTop: '10px' }}>
                                            <div style={{
                                                fontWeight: 500,
                                                color: '#000',
                                                minWidth: '90px',
                                                fontSize: '0.9rem',
                                            }}>
                                                Total Bahan 
                                            </div>
                                            <div
                                                style={{
                                                flex: 1,
                                                padding: '4px 10px',
                                                backgroundColor: '#f1f1f1',
                                                borderBottom: '2px solid #0d3b66',
                                                textAlign: 'right',
                                                fontWeight: 'bold',
                                                color: '#333',
                                                fontSize: '0.9rem',
                                                borderTopRightRadius: '4px',
                                                borderBottomRightRadius: '4px',
                                                }}
                                            >
                                                {formatCurrency(getSelectedSubtotal("bahan", activeClaimNo))}
                                            </div>
                                        </div>
                                        <br />
                                    </>
                                    </Tab>

                                    {/* Tab Upload File */}
                                    <Tab eventKey="UploadFile" title="Upload PDF">
                                        <div className="col-md-12">
                                            {/* Kolom 1: File Pendukung  1 */}
                                            <div className="col-md-12">
                                                <div className="mb-3">
                                                    <label className="fw-semibold">
                                                    {Datapendukung?.namafilependukung1 ? 'Upload Ulang File Pendukung  1' : 'Upload File Pendukung  1'}
                                                    </label>
                                                    <div className="input-group">
                                                    <label className="btn btn-outline-secondary mb-0">
                                                        Pilih File
                                                        <input
                                                        type="file"
                                                        accept=".pdf, .jpg, .jpeg, .png"
                                                        hidden
                                                        onChange={(e) => handleFileAdditionalChange(e, Datapendukung?.rep_order_no, 1)}
                                                        />
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={Datapendukung?.namafilependukung1 || "Belum ada file"}
                                                        readOnly
                                                    />
                                                    </div>
                                                    {Datapendukung?.namafilependukung1 && (
                                                    <div className="d-flex gap-2 mt-2">
                                                        {/* Tombol Preview */}
                                                        <button
                                                        className="btn btn-light"
                                                        onClick={() => handlePreviewFile(Datapendukung?.rep_order_no, Datapendukung?.mimetype1, 1)}
                                                        >
                                                        <i className="bi bi-file-earmark-fill"></i> Preview
                                                        </button>

                                                        {/* Tombol Download */}
                                                        {(() => {
                                                        const fileObj =
                                                            base64Files[Datapendukung?.rep_order_no]?.filependukung1 ||
                                                            Datapendukung?.filependukung1;
                                                        const filename =
                                                            base64Files[Datapendukung?.rep_order_no]?.filependukung1?.filename ||
                                                            Datapendukung?.namafilependukung1 ||
                                                            'file';
                                                        const ext = filename.split('.').pop()?.toLowerCase() || '';
                                                        let mimeType = 'application/octet-stream';

                                                        if (['jpg', 'jpeg'].includes(ext)) mimeType = 'image/jpeg';
                                                        else if (ext === 'png') mimeType = 'image/png';
                                                        else if (ext === 'pdf') mimeType = 'application/pdf';

                                                        const base64 =
                                                            typeof fileObj === 'string' ? fileObj : fileObj?.base64 || '';
                                                        const base64WithPrefix = base64.startsWith('data:')
                                                            ? base64
                                                            : `data:${mimeType};base64,${base64}`;

                                                        return (
                                                            <a
                                                            href={base64WithPrefix}
                                                            download={filename}
                                                            className="btn btn-light"
                                                            >
                                                            <i className="bi bi-download"></i> Download
                                                            </a>
                                                        );
                                                        })()}
                                                    </div>
                                                    )}
                                                </div>
                                            </div>

                                            {/* Kolom 2: File Pendukung  2 */}
                                            <div className="col-md-12">
                                            <div className="mb-3">
                                                <label className="fw-semibold">
                                                {Datapendukung?.namafilependukung2 ? 'Upload Ulang File Pendukung  2' : 'Upload File Pendukung  2'}
                                                </label>
                                                <div className="input-group">
                                                <label className="btn btn-outline-secondary mb-0">
                                                    Pilih File
                                                    <input
                                                    type="file"
                                                    accept=".pdf, .jpg, .jpeg, .png"
                                                    hidden
                                                    onChange={(e) => handleFileAdditionalChange(e, Datapendukung?.rep_order_no, 2)}
                                                    />
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={Datapendukung?.namafilependukung2 || "Belum ada file"}
                                                    readOnly
                                                />
                                                </div>
                                                {Datapendukung?.namafilependukung2 && (
                                                    <div className="d-flex gap-2 mt-2">
                                                        {/* Tombol Preview */}
                                                        <button
                                                        className="btn btn-light"
                                                        onClick={() => handlePreviewFile(Datapendukung?.rep_order_no, Datapendukung?.mimetype2, 2)}
                                                        >
                                                        <i className="bi bi-file-earmark-fill"></i> Preview
                                                        </button>

                                                        {/* Tombol Download */}
                                                        {(() => {
                                                        const fileObj =
                                                            base64Files[Datapendukung?.rep_order_no]?.filependukung2 ||
                                                            Datapendukung?.filependukung2;
                                                        const filename =
                                                            base64Files[Datapendukung?.rep_order_no]?.filependukung2?.filename ||
                                                            Datapendukung?.namafilependukung2 ||
                                                            'file';
                                                        const ext = filename.split('.').pop()?.toLowerCase() || '';
                                                        let mimeType = 'application/octet-stream';

                                                        if (['jpg', 'jpeg'].includes(ext)) mimeType = 'image/jpeg';
                                                        else if (ext === 'png') mimeType = 'image/png';
                                                        else if (ext === 'pdf') mimeType = 'application/pdf';

                                                        const base64 =
                                                            typeof fileObj === 'string' ? fileObj : fileObj?.base64 || '';
                                                        const base64WithPrefix = base64.startsWith('data:')
                                                            ? base64
                                                            : `data:${mimeType};base64,${base64}`;

                                                        return (
                                                            <a
                                                            href={base64WithPrefix}
                                                            download={filename}
                                                            className="btn btn-light"
                                                            >
                                                            <i className="bi bi-download"></i> Download
                                                            </a>
                                                        );
                                                        })()}
                                                    </div>
                                                    )}
                                            </div>
                                            </div>

                                            {/* Kolom 3: File Pendukung  3 */}
                                            <div className="col-md-12">
                                            <div className="mb-3">
                                                <label className="fw-semibold">
                                                {Datapendukung?.namafilependukung3 ? 'Upload Ulang File Pendukung  3' : 'Upload File Pendukung  3'}
                                                </label>
                                                <div className="input-group">
                                                <label className="btn btn-outline-secondary mb-0">
                                                    Pilih File
                                                    <input
                                                    type="file"
                                                    accept=".pdf, .jpg, .jpeg, .png"
                                                    hidden
                                                    onChange={(e) => handleFileAdditionalChange(e, Datapendukung?.rep_order_no, 3)}
                                                    />
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={Datapendukung?.namafilependukung3 || "Belum ada file"}
                                                    readOnly
                                                />
                                                </div>
                                                {Datapendukung?.namafilependukung3 && (
                                                    <div className="d-flex gap-2 mt-2">
                                                        {/* Tombol Preview */}
                                                        <button
                                                        className="btn btn-light"
                                                        onClick={() => handlePreviewFile(Datapendukung?.rep_order_no, Datapendukung?.mimetype3, 3)}
                                                        >
                                                        <i className="bi bi-file-earmark-fill"></i> Preview
                                                        </button>

                                                        {/* Tombol Download */}
                                                        {(() => {
                                                        const fileObj =
                                                            base64Files[Datapendukung?.rep_order_no]?.filependukung3 ||
                                                            Datapendukung?.filependukung3;
                                                        const filename =
                                                            base64Files[Datapendukung?.rep_order_no]?.filependukung3?.filename ||
                                                            Datapendukung?.namafilependukung3 ||
                                                            'file';
                                                        const ext = filename.split('.').pop()?.toLowerCase() || '';
                                                        let mimeType = 'application/octet-stream';

                                                        if (['jpg', 'jpeg'].includes(ext)) mimeType = 'image/jpeg';
                                                        else if (ext === 'png') mimeType = 'image/png';
                                                        else if (ext === 'pdf') mimeType = 'application/pdf';

                                                        const base64 =
                                                            typeof fileObj === 'string' ? fileObj : fileObj?.base64 || '';
                                                        const base64WithPrefix = base64.startsWith('data:')
                                                            ? base64
                                                            : `data:${mimeType};base64,${base64}`;

                                                        return (
                                                            <a
                                                            href={base64WithPrefix}
                                                            download={filename}
                                                            className="btn btn-light"
                                                            >
                                                            <i className="bi bi-download"></i> Download
                                                            </a>
                                                        );
                                                        })()}
                                                    </div>
                                                    )}
                                            </div>
                                            </div>
                                            {/* Kolom 4: File Pendukung  4 */}
                                            <div className="col-md-12">
                                            <div className="mb-3">
                                                <label className="fw-semibold">
                                                {Datapendukung?.namafilependukung4 ? 'Upload Ulang File Pendukung  4' : 'Upload File Pendukung  4'}
                                                </label>
                                                <div className="input-group">
                                                <label className="btn btn-outline-secondary mb-0">
                                                    Pilih File
                                                    <input
                                                    type="file"
                                                    accept=".pdf, .jpg, .jpeg, .png"
                                                    hidden
                                                    onChange={(e) => handleFileAdditionalChange(e, Datapendukung?.rep_order_no, 4)}
                                                    />
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={Datapendukung?.namafilependukung4 || "Belum ada file"}
                                                    readOnly
                                                />
                                                </div>
                                                {Datapendukung?.namafilependukung4 && (
                                                    <div className="d-flex gap-2 mt-2">
                                                        {/* Tombol Preview */}
                                                        <button
                                                        className="btn btn-light"
                                                        onClick={() => handlePreviewFile(Datapendukung?.rep_order_no, Datapendukung?.mimetype4, 4)}
                                                        >
                                                        <i className="bi bi-file-earmark-fill"></i> Preview
                                                        </button>

                                                        {/* Tombol Download */}
                                                        {(() => {
                                                        const fileObj =
                                                            base64Files[Datapendukung?.rep_order_no]?.filependukung4 ||
                                                            Datapendukung?.filependukung4;
                                                        const filename =
                                                            base64Files[Datapendukung?.rep_order_no]?.filependukung4?.filename ||
                                                            Datapendukung?.namafilependukung4 ||
                                                            'file';
                                                        const ext = filename.split('.').pop()?.toLowerCase() || '';
                                                        let mimeType = 'application/octet-stream';

                                                        if (['jpg', 'jpeg'].includes(ext)) mimeType = 'image/jpeg';
                                                        else if (ext === 'png') mimeType = 'image/png';
                                                        else if (ext === 'pdf') mimeType = 'application/pdf';

                                                        const base64 =
                                                            typeof fileObj === 'string' ? fileObj : fileObj?.base64 || '';
                                                        const base64WithPrefix = base64.startsWith('data:')
                                                            ? base64
                                                            : `data:${mimeType};base64,${base64}`;

                                                        return (
                                                            <a
                                                            href={base64WithPrefix}
                                                            download={filename}
                                                            className="btn btn-light"
                                                            >
                                                            <i className="bi bi-download"></i> Download
                                                            </a>
                                                        );
                                                        })()}
                                                    </div>
                                                    )}
                                            </div>
                                            </div>
                                            {/* Kolom 5: File Pendukung  5 */}
                                            <div className="col-md-12">
                                            <div className="mb-3">
                                                <label className="fw-semibold">
                                                {Datapendukung?.namafilependukung5 ? 'Upload Ulang File Pendukung  5' : 'Upload File Pendukung  5'}
                                                </label>
                                                <div className="input-group">
                                                <label className="btn btn-outline-secondary mb-0">
                                                    Pilih File
                                                    <input
                                                    type="file"
                                                    accept=".pdf, .jpg, .jpeg, .png"
                                                    hidden
                                                    onChange={(e) => handleFileAdditionalChange(e, Datapendukung?.rep_order_no, 5)}
                                                    />
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={Datapendukung?.namafilependukung5 || "Belum ada file"}
                                                    readOnly
                                                />
                                                </div>
                                                {Datapendukung?.namafilependukung5 && (
                                                    <div className="d-flex gap-2 mt-2">
                                                        {/* Tombol Preview */}
                                                        <button
                                                        className="btn btn-light"
                                                        onClick={() => handlePreviewFile(Datapendukung?.rep_order_no, Datapendukung?.mimetype5, 5)}
                                                        >
                                                        <i className="bi bi-file-earmark-fill"></i> Preview
                                                        </button>

                                                        {/* Tombol Download */}
                                                        {(() => {
                                                        const fileObj =
                                                            base64Files[Datapendukung?.rep_order_no]?.filependukung5 ||
                                                            Datapendukung?.filependukung5;
                                                        const filename =
                                                            base64Files[Datapendukung?.rep_order_no]?.filependukung5?.filename ||
                                                            Datapendukung?.namafilependukung5 ||
                                                            'file';
                                                        const ext = filename.split('.').pop()?.toLowerCase() || '';
                                                        let mimeType = 'application/octet-stream';

                                                        if (['jpg', 'jpeg'].includes(ext)) mimeType = 'image/jpeg';
                                                        else if (ext === 'png') mimeType = 'image/png';
                                                        else if (ext === 'pdf') mimeType = 'application/pdf';

                                                        const base64 =
                                                            typeof fileObj === 'string' ? fileObj : fileObj?.base64 || '';
                                                        const base64WithPrefix = base64.startsWith('data:')
                                                            ? base64
                                                            : `data:${mimeType};base64,${base64}`;

                                                        return (
                                                            <a
                                                            href={base64WithPrefix}
                                                            download={filename}
                                                            className="btn btn-light"
                                                            >
                                                            <i className="bi bi-download"></i> Download
                                                            </a>
                                                        );
                                                        })()}
                                                    </div>
                                                    )}
                                            </div>
                                            </div>
                                        </div>
                                    </Tab>

                                    {/* Tab Upload File */}
                                    {/* <Tab eventKey="DeleteWO" title="Hapus Transaksi">
                                        <div className="col-md-12">
                                            
                                        </div>
                                    </Tab> */}
                                    


                                </Tabs>

                                </div>
                            </div>
                        </div>
                        
                        <div className="col-md-12 d-flex justify-content-end">
                            <button style={{margin: '8px',}} onClick={handleSubmit} className="btn btn-dark" disabled={submitButton ? true : false}>{submitButton ? 'Updating Data...' : 'Update Data'}</button>
                        </div>
                    </div>
                {/* </form> */}
            </Modal>

            <Modal
            isOpen={!!previewBase64}
            onClose={() => setPreviewBase64(null)}
            title="Preview File Pendukung"
            modalId="modal-preview-pdf"
            >
            <div style={{ width: '100%', height: '80vh' }}>
                {previewBase64 && (
                previewBase64.mime === 'application/pdf' ? (
                    <embed
                    src={previewBase64.src}
                    type="application/pdf"
                    width="100%"
                    height="100%"
                    />
                ) : (
                    <img
                    src={previewBase64.src}
                    alt="Preview"
                    style={{ width: '100%', maxHeight: '100%', objectFit: 'contain' }}
                    />
                )
                )}
            </div>
            </Modal>
            </>
        );
    }
    //End Line Modal Detail Claim WO Is Here ! -------------------------------------------------------------------------------------------------------------------------------------------------------------------------

    //-------------------------------------------------------------------------------------------------------------------------------------
    //Event Log
    //-------------------------------------------------------------------------------------------------------------------------------------
    const renderEventLogModal = () => {
        return (
            <Modal isOpen={isEventLogModalOpen} onClose={closeEventLogModal} title={'Event Log'} modalId={selectedData?.rep_order_no}>
                <div className="row g-3">
                    <div className='col-md-6'>
                        <p className='m-0 p-0 fw-semibold'>Nomor WO</p>
                        <input
                            type="text"
                            id="nomor"
                            className="form-control"
                            value={selectedData?.rep_order_no ?? '-'}
                            style={{
                                flex: 1,
                                padding: '4px 10px',
                                backgroundColor: '#f1f1f1',
                                borderBottom: '2px solid #0d3b66',
                                fontWeight: 'bold',
                                color: '#333',
                                fontSize: '0.9rem',
                                width: '200px',
                                borderTopRightRadius: '4px',
                                borderBottomRightRadius: '4px',
                                textAlign: 'left' // <-- ini kuncinya
                                }}
                            readOnly
                        />
                    </div>
                    <div className='col-md-6'>
                        <p className='m-0 p-0 fw-semibold'>Proses ID</p>
                        <input
                            type="text"
                            id="nomor"
                            className="form-control"
                            value={selectedData?.claim_process_no ?? '-'}
                            style={{
                                flex: 1,
                                padding: '4px 10px',
                                backgroundColor: '#f1f1f1',
                                borderBottom: '2px solid #0d3b66',
                                fontWeight: 'bold',
                                color: '#333',
                                fontSize: '0.9rem',
                                width: '200px',
                                borderTopRightRadius: '4px',
                                borderBottomRightRadius: '4px',
                                textAlign: 'left' // <-- ini kuncinya
                                }}
                            readOnly
                        />
                    </div>
                    <div className='col-md-12'>
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='card'>
                                    <div className='card-body'>
                                        <div className='row'>
                                            <div className='col-md-12'>
                                                    <DataTable 
                                                        value={eventlogData} 
                                                        paginator 
                                                        showGridlines 
                                                        rows={5} 
                                                        globalFilterFields={['title', 'body']} 
                                                        dataKey="id" 
                                                        emptyMessage="Event Log Kosong"
                                                        className="fs-12">
                                                        <Column header="No" body={(rowData) => (
                                                            <>
                                                                <p className='text-secondary m-0 p-0'>{rowData.seq}</p>
                                                            </>
                                                        )} />
                                                        <Column field="Message Type" header="Message Type" body={(rowData) => (
                                                            <>
                                                                <p className='text-secondary m-0 p-0'>{rowData.msgType}</p>
                                                            </>
                                                        )} />
                                                        <Column field="Prosess Location" header="Prosess Location" body={(rowData) => (
                                                            <>
                                                                <p className='text-secondary m-0 p-0'>{rowData.processLocation}</p>
                                                            </>
                                                        )} />
                                                        <Column field="Message" header="Message" body={(rowData) => (
                                                            <>
                                                                <p className='text-secondary m-0 p-0'>{rowData.message}</p>
                                                            </>
                                                        )} />
                                                    </DataTable>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }

    //-------------------------------------------------------------------------------------------------------------------------------------
    //Upload File
    //-------------------------------------------------------------------------------------------------------------------------------------
    const renderUploadModal = () => {
            const handleFilesChange = (e, claimNo, jenis) => {
                const file = e.target.files[0];
                if (!file) return;

                const reader = new FileReader();

                reader.onload = () => {
                    const base64Raw = reader.result.split(',')[1];
                    const fileName = file.name;
                    const ext = fileName.split('.').pop().toLowerCase();

                    // deteksi MIME type
                    let mimeType = 'application/octet-stream';
                    switch (ext) {
                        case 'jpg':
                        case 'jpeg':
                            mimeType = 'image/jpeg';
                            break;
                        case 'png':
                            mimeType = 'image/png';
                            break;
                        case 'pdf':
                            mimeType = 'application/pdf';
                            break;
                    }

                    // bentuk format base64 lengkap
                    const base64Full = `data:${mimeType};base64,${base64Raw}`;

                    // simpan ke state base64Files
                    setBase64Files((prev) => ({
                        ...prev,
                        [claimNo]: {
                            ...(prev[claimNo] || {}),
                            [jenis]: {
                                base64: base64Raw,       // raw base64 (tanpa prefix)
                                base64Full,              // lengkap dengan prefix untuk preview
                                filename: fileName,
                                mimeType,                // tambahan info MIME type
                            },
                        },
                    }));

                    // update juga selectedData biar nama file keliatan di input text
                    setSelectedData((prev) => ({
                        ...prev,
                        [`nama${jenis}`]: fileName,
                        [jenis]: base64Raw,
                        [`mimeType_${jenis}`]: mimeType, // bisa dipakai kalau mau kirim MIME type juga
                    }));
                };

                reader.readAsDataURL(file);
            };
        
            const handlePreviewFiles = (claimNo, type, file) => {
                // Ambil data base64 dari upload baru atau data lama
                const fileObj =
                    base64Files[claimNo]?.[file] ||
                    selectedData?.[file];

                if (!fileObj) return;

                // Ambil base64 dan nama file
                const base64 = fileObj.base64 || fileObj;
                const filename = fileObj.filename || '';
                const ext = filename.split('.').pop()?.toLowerCase() || '';

                // Tentukan mime type berdasarkan ekstensi
                let mimeType = 'application/octet-stream';
                if (['jpg', 'jpeg'].includes(ext)) mimeType = 'image/jpeg';
                else if (ext === 'png') mimeType = 'image/png';
                else if (ext === 'pdf') mimeType = 'application/pdf';
                else mimeType = type;

                // Tambahkan prefix data base64 jika belum ada
                const base64WithPrefix = base64.startsWith('data:')
                    ? base64
                    : `data:${mimeType};base64,${base64}`;

                // Kirim ke state preview
                setPreviewBase64({
                    src: base64WithPrefix,
                    mime: mimeType,
                });
            };
        return (
            <>
            <Modal isOpen={isUploadFileModalOpen} onClose={closeUploadFileModal} title={'Detail Paperless'} modalId={selectedData?.rep_order_no}>
                <div className="row g-3">
                    <div className="col-md-6">
                        <label className="form-label">Nomor Faktur</label>
                        <input
                        type="text"
                        className="form-control input-flat"
                        value={selectedData?.noinvoice ?? '-'}
                        readOnly
                        />
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">Nomor WO</label>
                        <input
                        type="text"
                        className="form-control input-flat"
                        value={selectedData?.rep_order_no ?? '-'}
                        readOnly
                        />
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">Nomor Claim</label>
                        <input
                        type="text"
                        className="form-control input-flat"
                        value={selectedData?.claim_no ?? '-'}
                        readOnly
                        />
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">Nomor Proses</label>
                        <input
                        type="text"
                        className="form-control input-flat"
                        value={selectedData?.claim_process_no ?? '-'}
                        readOnly
                        />
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">Nomor TWC</label>
                        <input
                            type="text"
                            name="nomor_twc"
                            className="form-control input-flat"
                            value={selectedData?.twc_no ?? ''}
                            onChange={(e) =>
                                setSelectedData((prev) => ({ ...prev, twc_no: e.target.value }))
                            }
                        />
                    </div>

                    <div className="col-md-12">
                        {/* Kolom 1: File Faktur Dealer System*/}
                        <div className="col-md-12">
                            <div className="mb-3">
                                <label className="fw-semibold">
                                {selectedData?.namafilefakturdms ? 'Upload Ulang File Faktur Dealer System' : 'Upload File Faktur Dealer System'}
                                </label>
                                <div className="input-group">
                                <label className="btn btn-outline-secondary mb-0">
                                    Pilih File
                                    <input
                                    type="file"
                                    accept=".pdf, .jpg, .jpeg, .png"
                                    hidden
                                    onChange={(e) => handleFilesChange(e, selectedData?.rep_order_no, "filefakturdms")}
                                    />
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={selectedData?.namafilefakturdms || "Belum ada file"}
                                    readOnly
                                />
                                </div>
                                {selectedData?.namafilefakturdms && (
                                <div className="d-flex gap-2 mt-2">
                                    {/* Tombol Preview */}
                                    <button
                                    className="btn btn-light"
                                    onClick={() => handlePreviewFiles(selectedData?.rep_order_no, selectedData?.filefakturdms_mimetype, 'filefakturdms')}
                                    >
                                    <i className="bi bi-file-earmark-fill"></i> Preview
                                    </button>

                                    {/* Tombol Download */}
                                    {(() => {
                                    const fileObj =
                                        base64Files[selectedData?.rep_order_no]?.filefakturdms ||
                                        selectedData?.filefakturdms;
                                    const filename =
                                        base64Files[selectedData?.rep_order_no]?.filefakturdms?.filename ||
                                        selectedData?.namafilefakturdms ||
                                        'file';
                                    const ext = filename.split('.').pop()?.toLowerCase() || '';
                                    let mimeType = 'application/octet-stream';

                                    if (['jpg', 'jpeg'].includes(ext)) mimeType = 'image/jpeg';
                                    else if (ext === 'png') mimeType = 'image/png';
                                    else if (ext === 'pdf') mimeType = 'application/pdf';

                                    const base64 =
                                        typeof fileObj === 'string' ? fileObj : fileObj?.base64 || '';
                                    const base64WithPrefix = base64.startsWith('data:')
                                        ? base64
                                        : `data:${mimeType};base64,${base64}`;

                                    return (
                                        <a
                                        href={base64WithPrefix}
                                        download={filename}
                                        className="btn btn-light"
                                        >
                                        <i className="bi bi-download"></i> Download
                                        </a>
                                    );
                                    })()}
                                </div>
                                )}
                            </div>
                        </div>
                        {/* Kolom 1: File Faktur Pajak */}
                        <div className="col-md-12">
                            <div className="mb-3">
                                <label className="fw-semibold">
                                {selectedData?.namafilefakturpajak ? 'Upload Ulang File Faktur Pajak' : 'Upload File Faktur Pajak'}
                                </label>
                                <div className="input-group">
                                <label className="btn btn-outline-secondary mb-0">
                                    Pilih File
                                    <input
                                    type="file"
                                    accept=".pdf, .jpg, .jpeg, .png"
                                    hidden
                                    onChange={(e) => handleFilesChange(e, selectedData?.rep_order_no, "filefakturpajak")}
                                    />
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={selectedData?.namafilefakturpajak || "Belum ada file"}
                                    readOnly
                                />
                                </div>
                                {selectedData?.namafilefakturpajak && (
                                <div className="d-flex gap-2 mt-2">
                                    {/* Tombol Preview */}
                                    <button
                                    className="btn btn-light"
                                    onClick={() => handlePreviewFiles(selectedData?.rep_order_no, selectedData?.mimetype1, 'filefakturpajak')}
                                    >
                                    <i className="bi bi-file-earmark-fill"></i> Preview
                                    </button>

                                    {/* Tombol Download */}
                                    {(() => {
                                    const fileObj =
                                        base64Files[selectedData?.rep_order_no]?.filefakturpajak ||
                                        selectedData?.filefakturpajak;
                                    const filename =
                                        base64Files[selectedData?.rep_order_no]?.filefakturpajak?.filename ||
                                        selectedData?.namafilefakturpajak ||
                                        'file';
                                    const ext = filename.split('.').pop()?.toLowerCase() || '';
                                    let mimeType = 'application/octet-stream';

                                    if (['jpg', 'jpeg'].includes(ext)) mimeType = 'image/jpeg';
                                    else if (ext === 'png') mimeType = 'image/png';
                                    else if (ext === 'pdf') mimeType = 'application/pdf';

                                    const base64 =
                                        typeof fileObj === 'string' ? fileObj : fileObj?.base64 || '';
                                    const base64WithPrefix = base64.startsWith('data:')
                                        ? base64
                                        : `data:${mimeType};base64,${base64}`;

                                    return (
                                        <a
                                        href={base64WithPrefix}
                                        download={filename}
                                        className="btn btn-light"
                                        >
                                        <i className="bi bi-download"></i> Download
                                        </a>
                                    );
                                    })()}
                                </div>
                                )}
                            </div>
                        </div>
                    </div>
                    
                   <div className="col-md-12 d-flex justify-content-end gap-2 mt-3">
                        <button
                            onClick={handleSendMFT}
                            className="btn btn-dark"
                        >
                            {sendPaperlessButton ? 'Sending To MFT...' : 'Send MFT'}
                        </button>

                        <button
                            onClick={handleUpdatePaperless}
                            className="btn btn-dark"
                        >
                            {updatePaperlessButton ? 'Updating Data...' : 'Update Data'}
                        </button>
                    </div>
                </div>
            </Modal>

            <Modal
            isOpen={!!previewBase64}
            onClose={() => setPreviewBase64(null)}
            title="Preview File Pendukung"
            modalId="modal-preview-pdf"
            >
            <div style={{ width: '100%', height: '80vh' }}>
                {previewBase64 && (
                previewBase64.mime === 'application/pdf' ? (
                    <embed
                    src={previewBase64.src}
                    type="application/pdf"
                    width="100%"
                    height="100%"
                    />
                ) : (
                    <img
                    src={previewBase64.src}
                    alt="Preview"
                    style={{ width: '100%', maxHeight: '100%', objectFit: 'contain' }}
                    />
                )
                )}
            </div>
            </Modal>
            </>
        );
    }
    //End Line Modal Event Log Is Here ! -------------------------------------------------------------------------------------------------------------------------------------------------------------------------

    //-------------------------------------------------------------------------------------------------------------------------------------
    //Upload File
    //-------------------------------------------------------------------------------------------------------------------------------------
    const renderExportModal = () => {
        return (
            <>
            <Modal isOpen={isExportModalOpen} onClose={closeExportModal} title={'Export Excel'}>
                <div className="row g-3">

                    {/* Tanggal Dari */}
                    <div className="col-md-6">
                        <label className="form-label fw-bold">Tanggal Dari</label>
                        <input
                            type="date"
                            className="form-control"
                            value={dateFrom}
                            onChange={(e) => setDateFrom(e.target.value)}
                        />
                    </div>

                    {/* Tanggal Sampai */}
                    <div className="col-md-6">
                        <label className="form-label fw-bold">Tanggal Sampai</label>
                        <input
                            type="date"
                            className="form-control"
                            value={dateTo}
                            onChange={(e) => setDateTo(e.target.value)}
                        />
                    </div>

                    {/* Tombol Export */}
                    <div className="col-md-12 d-flex justify-content-end gap-2 mt-3">
                        <button
                            onClick={handleDownloadExcel}
                            className="btn btn-dark"
                        >
                            Export
                        </button>
                    </div>
                </div>
            </Modal>
            </>
        );
    };
    //End Line Modal Event Log Is Here ! -------------------------------------------------------------------------------------------------------------------------------------------------------------------------

    const editModal = renderEditModal();
    const eventLogModal = renderEventLogModal();
    const uploadModal = renderUploadModal();
    const exportModal = renderExportModal();

    // const onGlobalFilterChange = (e) => {
    //     const value = e.target.value;
        
    //     const _filters = {
    //         ...filters,
    //         global: { ...(filters?.global || {}), value },
    //     };
    
    //     setFilters(_filters);
    //     setSearch(value);
    // };

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        setSearch(value);
        setFilters((prev) => ({
            ...prev,
            global: { value, matchMode: "contains" },
        }));
    };

// Register Indonesian locale


    const renderHeader = () => {
        const getDateFromFilter = () => {
            if (filters?.repair_date?.value) {
                return new Date(filters.repair_date.value + "-01");
            }
            return null;
        };

        return (
            <div className="row align-items-center g-3 mb-3">
                {/* 🔍 Search box */}
               <div className="col-md-3 col-sm-12">
                    <InputSearch
                        iconLeft="bi bi-search"
                        iconRight="bi bi-filter"
                        type="text"
                        name="search"
                        placeholder="Cari Nomor WO"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)} // hanya update state
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                fetchData(1, rows, search); // baru hit backend
                            }
                        }}
                        className="form-control"
                    />
                </div>

                {/* 🔽 Status Filter */}
                <div className="col-md-auto d-flex align-items-center">
                    <label
                        htmlFor="statusClaimFilter"
                        className="fw-bold mb-0 me-2"
                        style={{ whiteSpace: "nowrap" }}
                    >
                        Status/Periode :
                    </label>
                    <select
                        id="statusClaimFilter"
                        className="form-control"
                        style={{ minWidth: "180px" }}
                        value={filters?.statusclaim?.value || ""}
                        onChange={(e) =>
                            setFilters({
                                ...filters,
                                statusclaim: {
                                    value: e.target.value,
                                    matchMode: "equals",
                                },
                            })
                        }
                    >
                        <option value="">-- Semua --</option>
                        <option value="Belum Claim">Belum Claim</option>
                        <option value="Claim sudah diajukan">
                            Claim sudah diajukan
                        </option>
                        {/* <option value="Proses Validasi Dealer">
                            Proses Validasi Dealer
                        </option>
                        <option value="Proses Validasi TAM">
                            Proses Validasi TAM
                        </option> */}
                        <option value="Approved">Approved</option>
                        <option value="Reject">Reject</option>
                        <option value="Send MFT">Send MFT</option>

                    </select>
                </div>

                <div className="col-md-auto d-flex align-items-center gap-1">
                {/* 📅 Picker Periode */}
                    <div className="position-relative">
                        <DatePicker
                            selected={getDateFromFilter()}
                            onChange={(date) => {
                                if (date) {
                                    const year = date.getFullYear();
                                    const month = date.getMonth() + 1;
                                    const monthString = month < 10 ? `0${month}` : `${month}`;
                                    const filterValue = `${year}-${monthString}`;
                                    setFilters({
                                        ...filters,
                                        repair_date: {
                                            value: filterValue,
                                            matchMode: "contains",
                                        },
                                    });
                                } else {
                                    const { repair_date, ...restFilters } = filters;
                                    setFilters(restFilters);
                                }
                            }}
                            dateFormat="MMMM yyyy"
                            showMonthYearPicker
                            locale={id}
                            className="form-control pe-4"
                            placeholderText="Pilih bulan & tahun"
                            isClearable
                            wrapperClassName="w-auto"
                            autoComplete="on"
                        />
                        <i className="bi bi-calendar3 position-absolute top-50 end-0 translate-middle-y me-2 text-secondary"></i>
                    </div>

                    {/* 📤 Tombol Export */}
                    <button
                        className="btn btn-success ms-2"
                        type="button"
                        onClick={openExportModal}
                        title="Download Laporan Excel"
                    >
                        <i className="bi bi-file-earmark-excel"></i> Export
                    </button>
                </div>

                {/* 🔄 Refresh button (push ke kanan) */}
                <div className="col-md-auto ms-auto">
                    <button
                        type="button"
                        className="btn btn-outline-secondary d-flex align-items-center px-3"
                        onClick={() => fetchData(1)}
                        title="Refresh data"
                    >
                        <i className="bi bi-arrow-clockwise me-1"></i> Refresh
                    </button>
                </div>
            </div>
        );
    };



    


    const header = renderHeader();

    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        });
        setSearch("");
    };

    // useEffect(() => {
    //     initFilters();
    //     dispatch(fetchCustomerReminders()).unwrap();
    //      // Set default ke bulan berjalan hanya jika belum ada filter repair_date
    //     if (!filters?.repair_date?.value) {
    //         const currentDate = new Date();
    //         const year = currentDate.getFullYear();
    //         const month = currentDate.getMonth() + 1;
    //         const monthString = month < 10 ? `0${month}` : `${month}`;
    //         const filterValue = `${year}-${monthString}`;
            
    //         setFilters(prevFilters => ({
    //             ...prevFilters,
    //             repair_date: {
    //                 value: filterValue,
    //                 matchMode: "contains",
    //             },
    //         }));
    //     }
    // },[dispatch])

    useEffect(() => {
        // inisialisasi filter awal
        initFilters();

        // set default bulan berjalan (jika belum ada)
        if (!filters?.repair_date?.value) {
            const currentDate = new Date();
            const year = currentDate.getFullYear();
            const month = currentDate.getMonth() + 1;
            const monthString = month < 10 ? `0${month}` : `${month}`;
            const filterValue = `${year}-${monthString}`;

            setFilters(prev => ({
                ...prev,
                repair_date: {
                    value: filterValue,
                    matchMode: "contains",
                },
            }));
        }

        // ⬇️ ganti ini: jangan dispatch langsung fetchCustomerReminders()
        // tapi panggil fungsi fetchData(1) (biar kirim page, limit, filter)
        fetchData(1);
    }, []);

    // ⬇️ tambah ini biar otomatis refetch kalau filter berubah
    useEffect(() => {
        // debounce kecil biar gak terlalu sering hit API
        const delayDebounce = setTimeout(() => {
            fetchData(1);
        }, 300);
        return () => clearTimeout(delayDebounce);
    }, [filters]);


    return (
        <>
        {/* ---------------------------------------------- */}
        {/* Loading Proccess Claim */}
        {/* ---------------------------------------------- */}
        {isLoadingClaim && (
            <>
                {/* Backdrop */}
                <div className="modal-backdrop fade show" style={{ zIndex: 1050 }}></div>

                {/* Loading Modal */}
                <div
                    className="modal fade show d-block"
                    tabIndex="-1"
                    style={{
                        background: 'rgba(0, 0, 0, 0.2)',
                        zIndex: 1060,
                    }}
                >
                    <div className="modal-dialog modal-dialog-centered">
                        <div
                            className="modal-content p-4"
                            style={{
                                borderRadius: '12px',
                                boxShadow: '0 0 10px rgba(0,0,0,0.15)',
                                textAlign: 'center',
                            }}
                        >
                            <h5 className="mb-3 fw-bold">Please Wait..</h5>
                            
                            <div className="d-flex justify-content-center align-items-center mb-2">
                                <div
                                    className="spinner-border text-success"
                                    role="status"
                                    style={{ width: '2rem', height: '2rem' }}
                                >
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>

                            <p className="text-muted mb-0">Preparing to send claim...</p>
                        </div>
                    </div>
                </div>
            </>
        )}
        {/* Line Loading Detail WO Is Here ! ---------------------------------------------- */}

        {/* ---------------------------------------------- */}
        {/* Loading Proccess Update */}
        {/* ---------------------------------------------- */}
        {isLoadingUpdate && (
            <>
                {/* Backdrop */}
                <div className="modal-backdrop fade show" style={{ zIndex: 1050 }}></div>

                {/* Loading Modal */}
                <div
                    className="modal fade show d-block"
                    tabIndex="-1"
                    style={{
                        background: 'rgba(0, 0, 0, 0.2)',
                        zIndex: 1060,
                    }}
                >
                    <div className="modal-dialog modal-dialog-centered">
                        <div
                            className="modal-content p-4"
                            style={{
                                borderRadius: '12px',
                                boxShadow: '0 0 10px rgba(0,0,0,0.15)',
                                textAlign: 'center',
                            }}
                        >
                            <h5 className="mb-3 fw-bold">Please Wait..</h5>
                            
                            <div className="d-flex justify-content-center align-items-center mb-2">
                                <div
                                    className="spinner-border text-success"
                                    role="status"
                                    style={{ width: '2rem', height: '2rem' }}
                                >
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>

                            <p className="text-muted mb-0">Preparing to Update WO...</p>
                        </div>
                    </div>
                </div>
            </>
        )}
        {/* Line Loading Detail WO Is Here ! ---------------------------------------------- */}

        {/* ---------------------------------------------- */}
        {/* Loading Proccess Update Paperless */}
        {/* ---------------------------------------------- */}
        {isLoadingUpdatePaperless && (
            <>
                {/* Backdrop */}
                <div className="modal-backdrop fade show" style={{ zIndex: 1050 }}></div>

                {/* Loading Modal */}
                <div
                    className="modal fade show d-block"
                    tabIndex="-1"
                    style={{
                        background: 'rgba(0, 0, 0, 0.2)',
                        zIndex: 1060,
                    }}
                >
                    <div className="modal-dialog modal-dialog-centered">
                        <div
                            className="modal-content p-4"
                            style={{
                                borderRadius: '12px',
                                boxShadow: '0 0 10px rgba(0,0,0,0.15)',
                                textAlign: 'center',
                            }}
                        >
                            <h5 className="mb-3 fw-bold">Please Wait..</h5>
                            
                            <div className="d-flex justify-content-center align-items-center mb-2">
                                <div
                                    className="spinner-border text-success"
                                    role="status"
                                    style={{ width: '2rem', height: '2rem' }}
                                >
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>

                            <p className="text-muted mb-0">Preparing to Update Paperless...</p>
                        </div>
                    </div>
                </div>
            </>
        )}
        {/* Line Loading Detail WO Is Here ! ---------------------------------------------- */}

        {/* ---------------------------------------------- */}
        {/* Loading Proccess Send Paperless */}
        {/* ---------------------------------------------- */}
        {isLoadingSendPaperless && (
            <>
                {/* Backdrop */}
                <div className="modal-backdrop fade show" style={{ zIndex: 1050 }}></div>

                {/* Loading Modal */}
                <div
                    className="modal fade show d-block"
                    tabIndex="-1"
                    style={{
                        background: 'rgba(0, 0, 0, 0.2)',
                        zIndex: 1060,
                    }}
                >
                    <div className="modal-dialog modal-dialog-centered">
                        <div
                            className="modal-content p-4"
                            style={{
                                borderRadius: '12px',
                                boxShadow: '0 0 10px rgba(0,0,0,0.15)',
                                textAlign: 'center',
                            }}
                        >
                            <h5 className="mb-3 fw-bold">Please Wait..</h5>
                            
                            <div className="d-flex justify-content-center align-items-center mb-2">
                                <div
                                    className="spinner-border text-success"
                                    role="status"
                                    style={{ width: '2rem', height: '2rem' }}
                                >
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>

                            <p className="text-muted mb-0">Preparing to Sending Paperless To MFT...</p>
                        </div>
                    </div>
                </div>
            </>
        )}
        {/* Line Loading Detail WO Is Here ! ---------------------------------------------- */}

        {/* ---------------------------------------------- */}
        {/* Loading Getting Event Log */}
        {/* ---------------------------------------------- */}
        {isLoadingEventLog && (
            <>
                {/* Backdrop */}
                <div className="modal-backdrop fade show" style={{ zIndex: 1050 }}></div>

                {/* Loading Modal */}
                <div
                    className="modal fade show d-block"
                    tabIndex="-1"
                    style={{
                        background: 'rgba(0, 0, 0, 0.2)',
                        zIndex: 1060,
                    }}
                >
                    <div className="modal-dialog modal-dialog-centered">
                        <div
                            className="modal-content p-4"
                            style={{
                                borderRadius: '12px',
                                boxShadow: '0 0 10px rgba(0,0,0,0.15)',
                                textAlign: 'center',
                            }}
                        >
                            <h5 className="mb-3 fw-bold">Please Wait..</h5>
                            
                            <div className="d-flex justify-content-center align-items-center mb-2">
                                <div
                                    className="spinner-border text-success"
                                    role="status"
                                    style={{ width: '2rem', height: '2rem' }}
                                >
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>

                            <p className="text-muted mb-0">Getting Event Log...</p>
                        </div>
                    </div>
                </div>
            </>
        )}
        {/* Line Loading Event Log Is Here ! ---------------------------------------------- */}

        {/* ---------------------------------------------- */}
        {/* Loading Getting History Claim By VIN */}
        {/* ---------------------------------------------- */}
        {isLoadingHistoryVIN && (
            <>
                {/* Backdrop */}
                <div className="modal-backdrop fade show" style={{ zIndex: 1050 }}></div>

                {/* Loading Modal */}
                <div
                    className="modal fade show d-block"
                    tabIndex="-1"
                    style={{
                        background: 'rgba(0, 0, 0, 0.2)',
                        zIndex: 1060,
                    }}
                >
                    <div className="modal-dialog modal-dialog-centered">
                        <div
                            className="modal-content p-4"
                            style={{
                                borderRadius: '12px',
                                boxShadow: '0 0 10px rgba(0,0,0,0.15)',
                                textAlign: 'center',
                            }}
                        >
                            <h5 className="mb-3 fw-bold">Please Wait..</h5>
                            
                            <div className="d-flex justify-content-center align-items-center mb-2">
                                <div
                                    className="spinner-border text-success"
                                    role="status"
                                    style={{ width: '2rem', height: '2rem' }}
                                >
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>

                            <p className="text-muted mb-0">Preparing to Getting History Claim By VIN...</p>
                        </div>
                    </div>
                </div>
            </>
        )}
        {/* Line Getting History Claim By VIN Is Here ! ---------------------------------------------- */}

        {/* ---------------------------------------------- */}
        {/* Loading Getting History Claim By VIN */}
        {/* ---------------------------------------------- */}
        {isLoadingGetData && (
            <>
                {/* Backdrop */}
                <div className="modal-backdrop fade show" style={{ zIndex: 1050 }}></div>

                {/* Loading Modal */}
                <div
                    className="modal fade show d-block"
                    tabIndex="-1"
                    style={{
                        background: 'rgba(0, 0, 0, 0.2)',
                        zIndex: 1060,
                    }}
                >
                    <div className="modal-dialog modal-dialog-centered">
                        <div
                            className="modal-content p-4"
                            style={{
                                borderRadius: '12px',
                                boxShadow: '0 0 10px rgba(0,0,0,0.15)',
                                textAlign: 'center',
                            }}
                        >
                            <h5 className="mb-3 fw-bold">Please Wait..</h5>
                            
                            <div className="d-flex justify-content-center align-items-center mb-2">
                                <div
                                    className="spinner-border text-success"
                                    role="status"
                                    style={{ width: '2rem', height: '2rem' }}
                                >
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>

                            <p className="text-muted mb-0">Preparing to Getting Vehicles List ...</p>
                        </div>
                    </div>
                </div>
            </>
        )}
        {/* Line Getting History Claim By VIN Is Here ! ---------------------------------------------- */}

        <Main>
            {/* <div className='row my-3'>
                <div className='col-md-6'>
                    <h5 className='fw-semibold'>Claim Submission</h5>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">Claim Submission</li>
                            <li className="breadcrumb-item active">Form List</li>
                        </ol>
                    </nav>
                </div>
            </div> */}

            {/* <DashboardSummary selectedMonth={moment(filters?.repair_date?.value).format("YYYY-MM")} /> */}

           <DashboardSummary
                selectedMonth={moment(filters?.repair_date?.value).format("YYYY-MM")}
                onSelectStatus={handleSelectStatusFromSummary}
            />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                    <div className="card-body">
                        {/* === Tabs === */}
                        <ul className="nav nav-tabs mb-3" role="tablist">
                        <li className="nav-item">
                            <button
                            className={`nav-link ${activeTab === "claim" ? "active" : ""}`}
                            onClick={() => setActiveTab("claim")}
                            >
                            <i className="bi bi-clipboard-check me-1"></i> Claim Submission
                            </button>
                        </li>
                        <li className="nav-item">
                            <button
                            className={`nav-link ${activeTab === "history" ? "active" : ""}`}
                            onClick={() => setActiveTab("history")}
                            >
                            <i className="bi bi-clock-history me-1"></i> Claim History 
                            </button>
                        </li>
                        </ul>

                        {/* === Tab Content === */}
                        {activeTab === "claim" && (
                        <>
                            {header}
                            {/* {data.length <= 0 ? (
                            <Skeleton width="100%" height="20rem" borderRadius="10px" />
                            ) : ( */}
                            <DataTable
                                // value={customer_reminders}
                                // paginator
                                // showGridlines
                                // rows={6}
                                // dataKey="rep_order_no"
                                // filters={filters}
                                // globalFilterFields={["rep_order_no", "activity", "statusclaim"]}
                                // emptyMessage="Transaksi Tidak ditemukan."
                                // className="fs-12"
                                selection={selectedItems}
                                onSelectionChange={(e) => setSelectedItems(e.value)}
                                value={data}
                                lazy
                                paginator
                                rows={rows}
                                first={first}
                                totalRecords={totalRecords}
                                onPage={onPage}
                                onSort={onSort}
                                sortField={sortField}
                                sortOrder={sortOrder}
                                onFilter={onFilter}
                                loading={loading}
                                showGridlines
                                dataKey="rep_order_no"
                                emptyMessage={
                                                <div
                                                style={{
                                                    textAlign: "center",
                                                    padding: "40px 0",
                                                    color: "#6c757d",
                                                }}
                                                >
                                                <i
                                                    className="bi bi-inbox fs-1 d-block mb-3"
                                                    style={{ opacity: 0.4 }}
                                                ></i>
                                                <h6 className="fw-semibold mb-1">Tidak ada data ditemukan</h6>
                                                <p className="small mb-0" style={{ opacity: 0.8 }}>
                                                    Coba ubah filter pencarian atau periksa periode waktu yang dipilih.
                                                </p>
                                                </div>
                                            }
                                className="fs-12"
                            >
                                <Column selectionMode="multiple" headerStyle={{ width: "3rem" }} />
                                <Column
                                header="Nomor"
                                body={(rowData) =>
                                    isLoading ? <Skeleton /> : rowData?.rep_order_no ?? ""
                                }
                                />
                                <Column
                                header="Tanggal"
                                body={(rowData) =>
                                    isLoading ? <Skeleton /> : rowData?.repair_date ?? ""
                                }
                                />
                                <Column
                                header="Nama Customer"
                                body={(rowData) =>
                                    isLoading ? <Skeleton /> : rowData?.cust_name ?? ""
                                }
                                />
                               <Column
                                    field="statusclaim"
                                    header="Status Claim"
                                    body={(rowData) =>
                                        isLoading ? (
                                        <Skeleton />
                                        ) : (
                                        <div
                                            style={{
                                            display: "flex",
                                            justifyContent: "center",     // biar posisi badge tengah di cell
                                            }}
                                        >
                                            <span
                                            style={{
                                                display: "inline-flex",     // ✅ biar tetap 1 baris
                                                alignItems: "center",
                                                justifyContent: "center",
                                                whiteSpace: "nowrap",       // ✅ cegah teks turun
                                                padding: "4px 12px",
                                                borderRadius: "20px",
                                                fontWeight: "600",
                                                fontSize: "12px",
                                                color: "#fff",
                                                textTransform: "uppercase",
                                                backgroundColor:
                                                rowData?.statusclaim === "Approved"
                                                    ? "#27ae60"
                                                    : rowData?.statusclaim === "Reject"
                                                    ? "#e74c3c"
                                                    : rowData?.statusclaim === "Claim sudah diajukan"
                                                    ? "#3498db"
                                                    : rowData?.statusclaim === "Belum Claim"
                                                    ? "#f39c12"
                                                    : rowData?.statusclaim === "Send MFT"
                                                    ? "#8e44ad"
                                                    : "#7f8c8d",
                                            }}
                                            >
                                            {rowData?.statusclaim || "-"}
                                            </span>
                                        </div>
                                        )
                                    }
                                />


                                <Column
                                header="No. Proses Claim"
                                body={(rowData) =>
                                    isLoading ? <Skeleton /> : rowData?.claim_process_no ?? ""
                                }
                                />
                                <Column
                                header="Event Log"
                                body={(rowData) =>
                                    isLoading ? (
                                    <Skeleton />
                                    ) : (
                                    <button
                                        className="btn btn-light"
                                        type="button"
                                        onClick={() => openEventLogModal(rowData)}
                                        title="Event Log"
                                    >
                                        <i className="bi bi-chat-square-text-fill"></i>
                                    </button>
                                    )
                                }
                                />
                                <Column
                                header="Paperless"
                                body={(rowData) =>
                                    isLoading ? (
                                    <Skeleton />
                                    ) : (
                                    <button
                                        className="btn btn-light"
                                        type="button"
                                        disabled={
                                        rowData?.statusclaim === "Approved" || rowData?.statusclaim === "Send MFT" ? false : true
                                        }
                                        onClick={(e) => {
                                        e.stopPropagation();
                                        setSelectedItems((prev) => {
                                            if (
                                            !prev.some(
                                                (item) =>
                                                item.rep_order_no === rowData.rep_order_no
                                            )
                                            ) {
                                            return [...prev, rowData];
                                            }
                                            return prev;
                                        });
                                        openUploadModal(rowData);
                                        }}
                                        title="Upload Paperless"
                                    >
                                        <i className="bi bi-file-earmark-fill"></i>
                                    </button>
                                    )
                                }
                                />
                                <Column
                                header="Detail Item"
                                body={(rowData) =>
                                    isLoading ? (
                                    <Skeleton />
                                    ) : (
                                    <button
                                        className="btn btn-light"
                                        type="button"
                                        onClick={(e) => {
                                        e.stopPropagation();
                                        setSelectedItems((prev) => {
                                            if (
                                            !prev.some(
                                                (item) =>
                                                item.rep_order_no === rowData.rep_order_no
                                            )
                                            ) {
                                            return [...prev, rowData];
                                            }
                                            return prev;
                                        });
                                        openEditModal(rowData);
                                        }}
                                        title={
                                        rowData.claim_sender === true
                                            ? "Sudah diklaim"
                                            : "Detail Item"
                                        }
                                    >
                                        <i className="bi bi-card-checklist"></i>
                                    </button>
                                    )
                                }
                                />
                            </DataTable>
                            {/* )} */}

                            {editModal}
                            {eventLogModal}
                            {uploadModal}
                            {exportModal}
                            <hr />

                            <div className="col-md-12 d-flex justify-content-end">
                            <button
                                className="btn btn-dark"
                                disabled={submitClaimButton ? true : false}
                                onClick={handleSendClaim}
                                style={{
                                display:
                                    localStorage.getItem("grup") === "VIEWER"
                                    ? "none"
                                    : "inline-block",
                                }}
                            >
                                {submitClaimButton
                                ? "Submiting Submission..."
                                : "Submit Submission"}
                            </button>
                            </div>


                        </>
                        )}

                        {/* === HISTORY SERVICE TAB === */}
                        {activeTab === "history" && (
                        <div className="mt-3">
                            <div className="row align-items-center g-2 mb-3">
                                <div className="col-md-4 col-sm-12">
                                    <InputSearch
                                    iconLeft="bi bi-search"
                                    iconRight="bi bi-filter"
                                    type="text"
                                    name="vin"
                                    placeholder="Nomor VIN"
                                    value={vin}
                                    onChange={(e) => setVin(e.target.value)}
                                    className="form-control"
                                    />
                                </div>

                                <div className="col-md-auto d-flex align-items-center gap-2">
                                    <button
                                    type="button"
                                    className="btn btn-outline-secondary d-flex align-items-center px-3"
                                    onClick={handleSearchVin}
                                    title="Refresh data"
                                    >
                                    <i className="bi bi-search me-1"></i> Cari
                                    </button>

                                    <button
                                    type="button"
                                    className="btn btn-success d-flex align-items-center px-3"
                                    onClick={handleExportExcel}
                                    disabled={!historyData || historyData.length === 0}
                                    title="Export ke Excel"
                                    >
                                    <i className="bi bi-file-earmark-excel me-1"></i> Export
                                    </button>
                                </div>
                            </div>


                            <DataTable
                                value={historyData}
                                showGridlines
                                rows={10}
                                paginator
                                className="fs-12 nowrap-table"
                                emptyMessage={
                                                <div
                                                style={{
                                                    textAlign: "center",
                                                    padding: "40px 0",
                                                    color: "#6c757d",
                                                }}
                                                >
                                                <i
                                                    className="bi bi-inbox fs-1 d-block mb-3"
                                                    style={{ opacity: 0.4 }}
                                                ></i>
                                                <h6 className="fw-semibold mb-1">Tidak ada data ditemukan</h6>
                                                <p className="small mb-0" style={{ opacity: 0.8 }}>
                                                    Silahkan coba ganti VIN yang anda cari.
                                                </p>
                                                </div>
                                            }
                                >
                                <Column field="seqNo" header="No" />
                                <Column field="vin" header="VIN" />
                                <Column field="openo" header="Openo" />
                                <Column field="openoDesc" header="Openo Desc" />
                                <Column field="claimType" header="Claim Type" />
                                <Column
                                    field="repairDate"
                                    header="Repair Date"
                                    body={(rowData) =>
                                    rowData?.repairDate
                                        ? new Date(rowData.repairDate).toLocaleDateString("id-ID", {
                                            day: "2-digit",
                                            month: "short",
                                            year: "numeric",
                                        })
                                        : "-"
                                    }
                                />
                                <Column
                                    field="deliveryDate"
                                    header="Delivery Date"
                                    body={(rowData) =>
                                    rowData?.deliveryDate
                                        ? new Date(rowData.deliveryDate).toLocaleDateString("id-ID", {
                                            day: "2-digit",
                                            month: "short",
                                            year: "numeric",
                                        })
                                        : "-"
                                    }
                                />
                                <Column field="modelCode" header="Model Code" />
                                <Column
                                    field="claimDate"
                                    header="Claim Date"
                                    body={(rowData) =>
                                    rowData?.claimDate
                                        ? new Date(rowData.claimDate).toLocaleDateString("id-ID", {
                                            day: "2-digit",
                                            month: "short",
                                            year: "numeric",
                                        })
                                        : "-"
                                    }
                                />
                                <Column
                                    field="createDate"
                                    header="Create Date"
                                    body={(rowData) =>
                                    rowData?.createDate
                                        ? new Date(rowData.createDate).toLocaleDateString("id-ID", {
                                            day: "2-digit",
                                            month: "short",
                                            year: "numeric",
                                        })
                                        : "-"
                                    }
                                />
                                <Column field="status" header="Status Code" />
                                <Column
                                    field="statusDesc"
                                    header="Status Desc"
                                    body={(rowData) =>
                                    <span style={{
                                        fontWeight: "bold",
                                        color:
                                        rowData?.statusDesc === "Approve Claim"
                                            ? "green"
                                            : rowData?.statusDesc === "Reject By Validation"
                                            ? "red"
                                            : "black"
                                    }}>
                                        {rowData?.statusDesc ?? "-"}
                                    </span>
                                    }
                                />
                                <Column field="epCodeDealer" header="Dealer Code" />
                                <Column field="claimNo" header="Claim No" />
                                <Column field="companyName" header="Dealer Name" />
                                <Column
                                    field="punctualFlag"
                                    header="Punctual"
                                    body={(rowData) => (rowData.punctualFlag ? "✔️" : "❌")}
                                />
                                <Column field="km" header="KM" />
                                <Column field="programName" header="Program Name" />
                                <Column field="serviceNo" header="Service No" />
                                <Column
                                    field="extendedWarranty"
                                    header="Extended Warranty"
                                    body={(rowData) => (rowData.extendedWarranty ? "✔️" : "❌")}
                                />
                            </DataTable>
                        </div>
                        )}
                    </div>
                    </div>
                </div>
                </div>
        </Main>
        </>
    );
}

export default RemindersReport;